import React, { useState, useEffect, useMemo, memo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import Swal from "sweetalert2";
import io from "socket.io-client";
import {
  Container,
  Row,
  Col,
  Form,
  Table,
  Button,
  Modal,
  Offcanvas,
  Card,
} from "react-bootstrap";
import "../Profile/profilepage.css";
import { useNavigate } from "react-router-dom";
import { format2 } from "../../utils/money";

// Memoized PlayerRow component to prevent unnecessary re-renders
const PlayerRow = memo(({ player, lifoLots }) => {
  const lots = lifoLots[player.name] || [];

  if (lots.length === 0) {
    const purchaseValue = Number(player.value) || 0;
    const currentValue = Number(player.currentValue) || 0;
    const shareQty = Number(player.share_quantity) || 0;
    const totalValue = currentValue * shareQty;
    const plPerShare = currentValue - purchaseValue;
    const totalPL = plPerShare * shareQty;

    return (
      <tr key={player._id}>
        <td style={{ width: "20%" }} className="td1">
          {player.name || "N/A"}
        </td>
        <td style={{ width: "15%" }} className="td1">
          {purchaseValue.toFixed(2)}
        </td>
        <td style={{ width: "15%" }} className="td1">
          {currentValue.toFixed(2)}
        </td>
        <td style={{ width: "15%" }} className="td1">
          {shareQty}
        </td>
        <td style={{ width: "15%" }} className="td1">
          {totalValue.toFixed(2)}
        </td>
        <td
          style={{
            width: "10%",
            color: plPerShare > 0 ? "green" : plPerShare < 0 ? "red" : "black",
          }}
          className="td1"
        >
          {plPerShare > 0 ? "+" : ""}
          {plPerShare.toFixed(2)}
        </td>
        <td
          style={{
            width: "10%",
            color: totalPL > 0 ? "green" : totalPL < 0 ? "red" : "black",
          }}
          className="td1"
        >
          {totalPL > 0 ? "+" : ""}
          {totalPL.toFixed(2)}
        </td>
      </tr>
    );
  }

  return lots.map((lot, idx) => {
    const purchaseValue = Number(lot.price) || 0;
    const currentValue = Number(player.currentValue) || 0;
    const shareQty = Number(lot.qty) || 0;
    const totalValue = currentValue * shareQty;
    const plPerShare = currentValue - purchaseValue;
    const totalPL = plPerShare * shareQty;

    return (
      <tr key={`${player._id}-lot-${idx}`}>
        <td style={{ width: "20%" }} className="td1">
          {player.name || "N/A"}
        </td>
        <td style={{ width: "15%" }} className="td1">
          {purchaseValue.toFixed(2)}
        </td>
        <td style={{ width: "15%" }} className="td1">
          {currentValue.toFixed(2)}
        </td>
        <td style={{ width: "15%" }} className="td1">
          {shareQty}
        </td>
        <td style={{ width: "15%" }} className="td1">
          {totalValue.toFixed(2)}
        </td>
        <td
          style={{
            width: "10%",
            color: plPerShare > 0 ? "green" : plPerShare < 0 ? "red" : "black",
          }}
          className="td1"
        >
          {plPerShare > 0 ? "+" : ""}
          {plPerShare.toFixed(2)}
        </td>
        <td
          style={{
            width: "10%",
            color: totalPL > 0 ? "green" : totalPL < 0 ? "red" : "black",
          }}
          className="td1"
        >
          {totalPL > 0 ? "+" : ""}
          {totalPL.toFixed(2)}
        </td>
      </tr>
    );
  });
});

const Navbar = ({ freezeMessage, userName, credits, withdrawableCredits, inPlayValue, differenceValue }) => {
  const [show1, setShow1] = useState(false);
  const navigate = useNavigate();

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const handleLogout = () => {
    localStorage.removeItem("user_token");
    localStorage.removeItem("fullName");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_isfrozen");
    localStorage.removeItem("email");
    console.log(`🟢 User logged out successfully at ${new Date().toISOString()}`);
    navigate("/");
  };

  return (
    <>
      <div className="freeze-banner">
        <p>{freezeMessage} </p>
      </div>

      <div className="user-info">
        <button
          variant="light"
          className="d-md-none menu-btn "
          onClick={handleShow1}
        >
          ☰
        </button>
        <div className="left-section1 d-flex1">
          <span className="welcome-text">Welcome, {userName}</span>
          <div className="top-navigation d-none d-md-flex">
            <span className="nav-item" onClick={() => navigate("/home")}>
              Home
            </span>
            <span
              className="nav-item active"
              onClick={() => navigate("/profile")}
            >
              Profile
            </span>
            <span className="nav-item" onClick={() => navigate("/myteam")}>
              My Team
            </span>
            <span className="nav-item" onClick={() => navigate("/faq")}>
              FAQs
            </span>
            <span className="nav-item" onClick={() => navigate("/news")}>
              News
            </span>
            <span className="nav-item" onClick={handleLogout}>
              Logout
            </span>
          </div>
        </div>

        <Offcanvas show={show1} onHide={handleClose1} placement="start">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="mobile-nav">
              <span
                className="nav-item "
                onClick={() => {
                  navigate("/home");
                  handleClose1();
                }}
              >
                Home
              </span>
              <span
                className="nav-item active"
                onClick={() => {
                  navigate("/profile");
                  handleClose1();
                }}
              >
                Profile
              </span>
              <span
                className="nav-item "
                onClick={() => {
                  navigate("/myteam");
                  handleClose1();
                }}
              >
                My Team
              </span>
              <span
                className="nav-item"
                onClick={() => {
                  navigate("/faq");
                  handleClose1();
                }}
              >
                FAQs
              </span>
              <span
                className="nav-item"
                onClick={() => {
                  navigate("/news");
                  handleClose1();
                }}
              >
                News
              </span>
              <span
                className="nav-item"
                onClick={() => {
                  handleLogout();
                  handleClose1();
                }}
              >
                Logout
              </span>
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        <div className="right-section1">
          <div className="credit-box-container">
            <button
              className="topup-button"
              onClick={() => {
                navigate("/topup");
              }}
            >
              Top-up
            </button>
            <div className="credit-box">
              <p className="p">
                Credit available: <span>{format2(credits + withdrawableCredits)}</span>
              </p>
              <p className="p">
                Withdrawable Credit: <span>{format2(withdrawableCredits)}</span>
              </p>
              <p className="p">
                In-play: <span>{inPlayValue.toFixed(2)}</span>
              </p>
              <p className="p">
                Current Team P/L:&nbsp;
                <span
                  style={{
                    color:
                      Number(differenceValue) > 0
                        ? "green"
                        : Number(differenceValue) < 0
                          ? "red"
                          : "black",
                  }}
                >
                  {differenceValue
                    ? Number(differenceValue) > 0
                      ? `+${Number(differenceValue).toFixed(2)}`
                      : Number(differenceValue).toFixed(2)
                    : "0.00"}
                </span>
              </p>
              {/* <button
                className="topup-button-mobile"
                onClick={() => {
                  navigate("/topup");
                }}
              >
                Top-up
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function ProfilePage() {
  const [profileData, setProfileData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    dob: "",
    credits: "",
    profile_image: "",
    team: null,
  });
  const [isMarketFrozen, setIsMarketFrozen] = useState(false);
  const [freezeMessage, setFreezeMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [password, setPassword] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [playerval, setplayerval] = useState(0);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [playerLots, setPlayerLots] = useState({});
  const [playersLoading, setPlayersLoading] = useState(true);
  const [players, setPlayers] = useState([]);
  const [inc, setInc] = useState(0);
  const [prevIsMarketFrozen, setPrevIsMarketFrozen] = useState(isMarketFrozen);

  const navigate = useNavigate();

  // Initialize Socket.IO connection
  const socket = useMemo(() => {
    const socketInstance = io("https://toptennis.io", {
      auth: {
        token: localStorage.getItem("user_token"),
      },
    });
    socketInstance.on("connect", () => {
      console.log(`🔌 Socket connected`);
    });
    socketInstance.on("connect_error", (error) => {
      console.error(`Socket connection error`, error.message);
    });
    socketInstance.on("disconnect", (reason) => {
      console.log(`Socket disconnected`, reason);
    });
    return socketInstance;
  }, []);

  const fetchMarketStatus = async () => {
    setIsLoading(true);
    try {
      const Token = localStorage.getItem("user_token");
      const response = await axios.get(
        "https://toptennis.io/api/users/market-status",
        {
          headers: { Authorization: `Bearer ${Token}` },
        }
      );
      const { isFrozen, bannerText } = response.data;
      setIsMarketFrozen(isFrozen);
      setFreezeMessage(bannerText || "");
      // console.log(`🔔 Market status fetched at ${new Date().toISOString()}:`, { isFrozen, bannerText });
    } catch (error) {
      console.error(`❌ Error fetching market status at ${new Date().toISOString()}:`, error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMarketStatus();
  }, []);

  const showAutoError = (message) => {
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 3000,
    });
  };

  // Fetch initial player data and set up socket
  useEffect(() => {
    const fetchPlayersAndMergeData = async () => {
      const Token = localStorage.getItem("user_token");
      try {
        const decodedToken = JSON.parse(atob(Token.split(".")[1]));
        const userId = decodedToken._id;

        // Initial fetch
        const response = await axios.get(
          `https://toptennis.io/api/users/selected-teamlist/${userId}`,
          { headers: { Authorization: `Bearer ${Token}` } }
        );

        if (response.data && response.data.status) {
          const { team, valueDifferences } = response.data;

          const valueDifferenceMap = valueDifferences.reduce(
            (acc, valueDifference) => {
              acc[valueDifference.player_id] = valueDifference;
              return acc;
            },
            {}
          );

          const mergedData = team.players.map((player) => {
            const differenceData = valueDifferenceMap[player._id] || {};
            return {
              ...player,
              currentValue: differenceData.value || player.value,
              valueDifference: differenceData.valueDifference || 0,
              latest_transaction_time: differenceData.latest_transaction_time || null,
              buy_qty: differenceData.buy_qty,
              sell_qty: differenceData.sell_qty,
              last_buy_price: differenceData.last_buy_price,
              last_buy_qty: differenceData.last_buy_qty,
              share_quantity: differenceData.share_quantity || player.share_quantity || 0,
              lastFreezePrice: player.lastFreezePrice || player.value,
              lastFreezeShareQty: player.lastFreezeShareQty || player.share_quantity || 0,
            };
          });

          setPlayers(mergedData);

          const lastChangedPlayer = mergedData.reduce((latest, player) => {
            if (!latest) return player;
            const latestTime = new Date(latest.latest_transaction_time || 0);
            const playerTime = new Date(player.latest_transaction_time || 0);
            return playerTime > latestTime ? player : latest;
          }, null);

          if (lastChangedPlayer) {
            const calculatedInc =
              (Number(lastChangedPlayer.valueDifference) || 0) *
              (Number(lastChangedPlayer.share_quantity) || 0);
            setplayerval(calculatedInc);
            setInc(calculatedInc);
          }
        }
      } catch (error) {
        console.error(`❌ Error fetching initial data at ${new Date().toISOString()}:`, error.message);
      } finally {
        setPlayersLoading(false);
      }
    };

    fetchPlayersAndMergeData();

    // Join user room for Socket.IO updates
    const Token = localStorage.getItem("user_token");
    if (Token) {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      socket.emit("joinUserRoom", decodedToken._id);
    }

    // Listen for player updates
    socket.on("playerUpdate", (data) => {
      const { team, valueDifferences } = data;

      if (!team || !Array.isArray(team.players) || !Array.isArray(valueDifferences)) {
        console.error(
          `❌ Invalid playerUpdate data structure at ${new Date().toISOString()}:`,
          JSON.stringify(data, null, 2)
        );
        return;
      }

      const valueDifferenceMap = valueDifferences.reduce(
        (acc, valueDifference) => {
          acc[valueDifference.player_id] = valueDifference;
          return acc;
        },
        {}
      );

      setPlayers((prevPlayers) => {
        const mergedData = prevPlayers.map((prevPlayer) => {
          const teamPlayer = team.players.find((p) => p._id === prevPlayer._id);
          const differenceData = valueDifferenceMap[prevPlayer._id] || {};

          if (teamPlayer && differenceData.player_id) {
            const updatedPlayer = {
              ...prevPlayer,
              currentValue: differenceData.value || prevPlayer.currentValue || prevPlayer.value,
              valueDifference: differenceData.valueDifference || prevPlayer.valueDifference || 0,
              latest_transaction_time: differenceData.latest_transaction_time || prevPlayer.latest_transaction_time || null,
              buy_qty: differenceData.buy_qty || prevPlayer.buy_qty,
              sell_qty: differenceData.sell_qty || prevPlayer.sell_qty,
              last_buy_price: differenceData.last_buy_price || prevPlayer.last_buy_price,
              last_buy_qty: differenceData.last_buy_qty || prevPlayer.last_buy_qty,
              share_quantity: differenceData.share_quantity || teamPlayer.share_quantity || prevPlayer.share_quantity || 0,
              lastFreezePrice: teamPlayer.lastFreezePrice || prevPlayer.lastFreezePrice || prevPlayer.value,
              lastFreezeShareQty: teamPlayer.lastFreezeShareQty || prevPlayer.lastFreezeShareQty || prevPlayer.share_quantity || 0,
            };
            return updatedPlayer;
          }
          return prevPlayer;
        });

        // Calculate inPlayValue (same as table's total current value)
        const newInPlayValue = mergedData.reduce(
          (sum, player) =>
            sum + (Number(player.currentValue) || 0) * (Number(player.share_quantity) || 0),
          0
        );
        setInPlayValue(newInPlayValue);
        // Calculate differenceValue (same as tableTotalPL)
        const newDifferenceValue = mergedData.reduce((total, player) => {
          const lots = lifoLots[player.name] || [];
          if (lots.length === 0) {
            const purchaseValue = Number(player.value) || 0;
            const currentValue = Number(player.currentValue) || 0;
            const shareQty = Number(player.share_quantity) || 0;
            const totalPL = (currentValue - purchaseValue) * shareQty;
            return total + totalPL;
          }
          return lots.reduce((sum, lot) => {
            const purchaseValue = Number(lot.price) || 0;
            const currentValue = Number(player.currentValue) || 0;
            const shareQty = Number(lot.qty) || 0;
            const totalPL = (currentValue - purchaseValue) * shareQty;
            return sum + totalPL;
          }, total);
        }, 0);
        setDifferenceValue(newDifferenceValue);

        return mergedData;
      });

      const lastChangedPlayer = valueDifferences.reduce((latest, diff) => {
        const player = team.players.find((p) => p._id === diff.player_id);
        if (!player) return latest;
        if (!latest) return { ...player, ...diff };
        const latestTime = new Date(latest.latest_transaction_time || 0);
        const playerTime = new Date(diff.latest_transaction_time || 0);
        return playerTime > latestTime ? { ...player, ...diff } : latest;
      }, null);

      if (lastChangedPlayer) {
        const calculatedInc =
          (Number(lastChangedPlayer.valueDifference) || 0) *
          (Number(lastChangedPlayer.share_quantity) || 0);
        setplayerval(calculatedInc);
        setInc(calculatedInc);
      } else {
        console.log(`⚠️ No last changed player found for inc calculation at ${new Date().toISOString()}`);
      }
    });


    return () => {
      console.log(`🧹 Disconnecting socket at ${new Date().toISOString()}`);
      socket.disconnect();
    };
  }, [socket]);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const Token = localStorage.getItem("user_token");
        const decodedToken = JSON.parse(atob(Token.split(".")[1]));
        const userId = decodedToken._id;

        const response = await axios.get(
          `https://toptennis.io/api/users/user/profile/${userId}`,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );


        if (response.data && response.data.userDetails) {
          const {
            name,
            email,
            password,
            credits,
            team,
            profile_image,
            phone,
            dob,
          } = response.data.userDetails;
          setProfileData({
            name: name || "",
            email: email || "",
            password: password || "",
            phone: phone || "",
            dob: dob || "",
            credits: credits || "",
            team: team || null,
            profile_image: profile_image || "",
          });
        }
      } catch (error) {
        console.error(`❌ Error fetching profile data at ${new Date().toISOString()}:`, error.message);
        if (error.response) {
          if (
            error.response.status === 500 &&
            error.response.data.message === "jwt expired"
          ) {
            showAutoError(error.response.data.message);
          } else {
            showAutoError("An error occurred while fetching profile data.");
          }
        }
      }
    };

    fetchProfileData();
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: profileData.name || "",
    password: profileData.password || "",
    email: profileData.email || "",
    dob: profileData.dob || "",
    phone: profileData.phone || "",
  });
  const [profileImage, setProfileImage] = useState(null);
  const [passwordError, setPasswordError] = useState("");
  const [DobError, setDobError] = useState("");
  const formatDOBForInput = (dob) => {
    if (!dob) return "";
    const date = new Date(dob);
    return date.toISOString().split("T")[0];
  };

  const handleEditClick = () => {
    setFormData({
      name: profileData.name,
      password: profileData.password,
      email: profileData.email,
      phone: profileData.phone,
      dob: formatDOBForInput(profileData.dob),
    });
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "password") {
      setIsEditing(true);
      setPassword(value);
      if (value.length > 12) {
        setPasswordError("Maximum 12 characters.");
      } else {
        setPasswordError("");
      }
    }

    if (name === "phone") {
      const phoneRegex = /^[0-9]*$/;
      if (value === "") {
        setPhoneError("");
      } else if (!phoneRegex.test(value)) {
        setPhoneError("Only numeric values are allowed.");
      } else if (value.length > 14) {
        setPhoneError("Maximum 14 digits allowed.");
      } else {
        setPhoneError("");
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
    }
  };

  const isUnder18 = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      return age - 1 < 18;
    }
    return age < 18;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password.length > 12) {
      setPasswordError("Password must be exactly 12 characters long.");
      return;
    }

    const numericRegex = /^[0-9]{9,14}$/;
    if (!numericRegex.test(formData.phone)) {
      setPhoneError(
        "Phone number must be 9 to 14 digits and contain only numbers."
      );
      return;
    }

    if (isUnder18(formData.dob)) {
      setDobError("You must be at least 18 years old.");
      return;
    }

    const result = await Swal.fire({
      title: "Confirm Profile Update",
      text: "You have changed your profile details. You will need to re-login. Continue?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, update & logout",
      denyButtonText: "No, keep existing",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-success me-2 btn-sm",
        denyButton: "btn btn-danger me-2 btn-sm",
        popup: "custom-popup",
        closeButton: "custom-close-btn",
      },
      didOpen: () => {
        const closeButton = document.querySelector(".swal2-close");
        closeButton.classList.add("custom-close-btn");
      },
    });

    if (result.isDenied || result.isDismissed) {
      return;
    }

    try {
      const Token = localStorage.getItem("user_token");
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      const data = new FormData();
      data.append("name", formData.name);
      data.append("password", formData.password);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      data.append("dob", formData.dob);
      if (profileImage) {
        data.append("profile_image", profileImage);
      }

      const response = await axios.patch(
        `https://toptennis.io/api/users/userdetails-updated/${userId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 201 || response.data.status) {
        navigate("/");
        setProfileData(response.data);
        setShowModal(false);
        localStorage.removeItem("user_token");
        console.log(`🟢 Profile updated and user logged out at ${new Date().toISOString()}`);
      }
    } catch (error) {
      console.error(`❌ Error updating user details at ${new Date().toISOString()}:`, error.message);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error.response?.data?.message || "Something went wrong!",
      });
    }
  };

  const [differenceValue, setDifferenceValue] = useState(0);
  const [inPlayValue, setInPlayValue] = useState(0);
  const [credits, setCredits] = useState(0);
  const [withdrawableCredits, setWithdrawableCredits] = useState(0);
  const [userName, setUserName] = useState(0);

  const fetchUserValues = async () => {
    const Token = localStorage.getItem("user_token");

    if (Token) {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      try {
        const response = await axios.get(
          `https://toptennis.io/api/users/user/in-play-value/${userId}`,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );

        const {
          name,
          credits,
          withdrawableCredits,
          grand_total_value,
          differenceValue,
          latest_inc,
        } = response.data;
        setUserName(name);
        setCredits(credits);
        setWithdrawableCredits(withdrawableCredits);
        setInPlayValue(grand_total_value);
        setDifferenceValue(differenceValue);
        setplayerval(latest_inc);
      } catch (error) {
        console.error(`❌ Error fetching in-play values at ${new Date().toISOString()}:`, error.message);
      }
    }
  };

  useEffect(() => {
    fetchUserValues();
  }, []);

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.convertkit.com/v3/forms/7878458/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: "3bkwOyREXJsvpFPZ5iUAAw",
            email: email,
          }),
        }
      );

      const data = await response.json();
      if (data.subscription) {
        setMessage(
          "Success! Please check your email to confirm your subscription."
        );
        setEmail("");
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Subscription failed. Please try again later.");
      console.error(`❌ Subscription error at ${new Date().toISOString()}:`, error.message);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [tradingHistory, setTradingHistory] = useState([]);

  useEffect(() => {
    const fetchTradingHistory = async () => {
      const Token = localStorage.getItem("user_token");
      if (!Token) return;
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      try {
        const response = await axios.get(
          `https://toptennis.io/api/users/user/trading-history/${userId}`,
          { headers: { Authorization: `Bearer ${Token}` } }
        );
        let history = [];
        if (Array.isArray(response.data)) {
          history = response.data;
        } else if (Array.isArray(response.data.data)) {
          history = response.data.data;
        } else if (Array.isArray(response.data.history)) {
          history = response.data.history;
        } else if (Array.isArray(response.data.transactions)) {
          history = response.data.transactions;
        }
        setTradingHistory(history);

        const lots = {};
        if (Array.isArray(history)) {
          history.forEach((tx) => {
            if (!lots[tx.player_name]) lots[tx.player_name] = [];
            if (tx.type === "buy") {
              lots[tx.player_name].push({
                price: tx.value,
                qty: tx.quantity,
                type: "buy",
                timestamp: tx.date,
              });
            } else if (tx.type === "sell") {
              lots[tx.player_name].push({
                price: tx.value,
                qty: tx.quantity,
                type: "sell",
                timestamp: tx.date,
              });
            }
          });
        }
        setPlayerLots(lots);
      } catch (error) {
        console.error(`❌ Error fetching trading history at ${new Date().toISOString()}:`, error.message);
      }
    };

    fetchTradingHistory();
  }, []);

  // Handle market freeze/unfreeze
  useEffect(() => {
    if (isMarketFrozen !== prevIsMarketFrozen) {
      console.log(
        `🔔 Market freeze state changed at ${new Date().toISOString()}:`,
        prevIsMarketFrozen,
        "->",
        isMarketFrozen
      );
      if (isMarketFrozen === false) {
        // Market just unfroze, reset lots
        setPlayerLots({});
        console.log(`🟢 Reset player lots on market unfreeze at ${new Date().toISOString()}`);
      }

      const prevFreezeData = getPrevFreezeData();
      let incSum = 0;

      setPlayers((prevPlayers) => {
        const updatedPlayers = prevPlayers.map((player) => {
          const prev = prevFreezeData[player._id];
          let inc = 0;
          if (prev) {
            inc =
              (player.currentValue - prev.lastFreezePrice) *
              prev.lastFreezeShareQty;
          }
          incSum += inc;
          const updatedPlayer = {
            ...player,
            lastFreezePrice: player.currentValue,
            lastFreezeShareQty: player.share_quantity,
            lastFreezeSellQty: player.sell_qty,
          };
          console.log(
            `🔄 Updated player ${player.name} on freeze change at ${new Date().toISOString()}:`,
            JSON.stringify(updatedPlayer, null, 2)
          );
          return updatedPlayer;
        });

        const newFreezeData = {};
        updatedPlayers.forEach((player) => {
          newFreezeData[player._id] = {
            lastFreezePrice: player.currentValue,
            lastFreezeShareQty: player.share_quantity,
            lastFreezeSellQty: player.sell_qty,
          };
        });
        setPrevFreezeData(newFreezeData);
        console.log(
          `🟢 Set prev freeze data at ${new Date().toISOString()}:`,
          JSON.stringify(newFreezeData, null, 2)
        );

        setInc(incSum);
        console.log(`🟢 Set inc on freeze change at ${new Date().toISOString()}:`, incSum);

        return updatedPlayers;
      });

      setPrevIsMarketFrozen(isMarketFrozen);
    }
  }, [isMarketFrozen]);

  const playerSummary = {};
  if (Array.isArray(tradingHistory) && tradingHistory.length > 0) {
    const lastBuyQtys = {};
    const sortedHistory = [...tradingHistory].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    );

    for (const tx of sortedHistory) {
      if (
        tx.type === "buy" &&
        typeof lastBuyQtys[tx.player_name] === "undefined"
      ) {
        lastBuyQtys[tx.player_name] = tx.quantity;
      }
    }

    tradingHistory.forEach((tx) => {
      if (!playerSummary[tx.player_name]) {
        playerSummary[tx.player_name] = {
          name: tx.player_name,
          totalBought: 0,
          totalSpent: 0,
          totalSold: 0,
          totalReceived: 0,
          transactions: [],
          last_buy_qty: lastBuyQtys[tx.player_name] || 0,
        };
      }
      if (tx.type === "buy") {
        playerSummary[tx.player_name].totalBought += tx.quantity;
        playerSummary[tx.player_name].totalSpent += tx.value * tx.quantity;
      } else if (tx.type === "sell") {
        playerSummary[tx.player_name].totalSold += tx.quantity;
        playerSummary[tx.player_name].totalReceived += tx.value * tx.quantity;
      }
      playerSummary[tx.player_name].transactions.push(tx);
    });
  }


  const getPrevFreezeData = () =>
    JSON.parse(localStorage.getItem("playerPrevFreezeData") || "{}");
  const setPrevFreezeData = (data) =>
    localStorage.setItem("playerPrevFreezeData", JSON.stringify(data));

  const safeInc = typeof inc === "number" && !isNaN(inc) ? inc : 0;

  function getLifoLots(tradingHistory, players) {
    const playerLots = {};
    players.forEach((player) => {
      playerLots[player.name] = [];
    });

    const sortedHistory = [...tradingHistory].sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

    for (const tx of sortedHistory) {
      if (!playerLots[tx.player_name]) playerLots[tx.player_name] = [];
      if (tx.type === "buy") {
        playerLots[tx.player_name].push({
          price: tx.value,
          qty: tx.quantity,
          originalQty: tx.quantity,
          date: tx.date,
        });
      } else if (tx.type === "sell") {
        let qtyToSell = tx.quantity;
        while (qtyToSell > 0 && playerLots[tx.player_name].length > 0) {
          const lastLot =
            playerLots[tx.player_name][playerLots[tx.player_name].length - 1];
          if (lastLot.qty > qtyToSell) {
            lastLot.qty -= qtyToSell;
            qtyToSell = 0;
          } else {
            qtyToSell -= lastLot.qty;
            playerLots[tx.player_name].pop();
          }
        }
      }
    }

    Object.keys(playerLots).forEach((name) => {
      playerLots[name] = playerLots[name].filter((lot) => lot.qty > 0);
    });

    return playerLots;
  }

  const lifoLots = useMemo(
    () => getLifoLots(tradingHistory, players),
    [tradingHistory, players]
  );

  const tableTotalPL = useMemo(() => {
    let total = 0;
    players.forEach((player) => {
      const lots = lifoLots[player.name] || [];
      if (lots.length === 0) {
        const purchaseValue = Number(player.value) || 0;
        const currentValue = Number(player.currentValue) || 0;
        const shareQty = Number(player.share_quantity) || 0;
        const totalPL = (currentValue - purchaseValue) * shareQty;
        total += totalPL;
      } else {
        lots.forEach((lot) => {
          const purchaseValue = Number(lot.price) || 0;
          const currentValue = Number(player.currentValue) || 0;
          const shareQty = Number(lot.qty) || 0;
          const totalPL = (currentValue - purchaseValue) * shareQty;
          total += totalPL;
        });
      }
    });
    const endTime = performance.now();
    return total;
  }, [players, lifoLots]);


  return (
    <>
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <Container className="justify-content-center align-items-center n-new cn">
        <Row className="w-100 justify-content-center rowdiv">
          <Navbar
            freezeMessage={freezeMessage}
            userName={userName}
            credits={credits}
            withdrawableCredits={withdrawableCredits}
            inPlayValue={inPlayValue}
            differenceValue={differenceValue}
          />
          <Col xs={12} sm={10} md={8}>
            <div
              style={{
                padding: "10px",
                background: "",
                borderRadius: "8px",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                height: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <h3 className="profile-title" style={{ margin: 0 }}>Profile Information</h3>
                <button
                  className="edit-profile-button"
                  onClick={handleEditClick}
                  style={{
                    color: "black",
                    border: "none",
                    borderRadius: "4px",
                    padding: "6px 16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "20px",
                  }}
                >
                  Edit Profile
                </button>
              </div>
              <div style={{ width: "100%", padding: "10px 10px 0", height: "auto", borderTop: "1px solid #c0c0c0" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", rowGap: "10px" }}>
                  <span><strong>Full Name:</strong></span>
                  <span>{profileData.name ? (profileData.name) : "..."}</span>

                  <span><strong>Email:</strong></span>
                  <span>{profileData.email ? (profileData.email) : "..."}</span>

                  <span><strong>Phone No.:</strong></span>
                  <span>{profileData.phone ? (profileData.phone) : "..."}</span>

                  <span><strong>DOB:</strong></span>
                  <span>{profileData.dob ? new Date(profileData.dob).toLocaleDateString("en-GB") : "..."}</span>

                  <span><strong>Credit available:</strong></span>
                  <span>{typeof profileData.credits === "number" ? format2(credits + withdrawableCredits) : "..."}</span>

                  <span><strong>Withdrawable Credits:</strong></span>
                  <span>{typeof profileData.credits === "number" ? format2(withdrawableCredits) : "..."}</span>
                </div>

                <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "10px", textAlign: "center" }}>
                  <Button variant="success" style={{ maxWidth: "250px" }} onClick={() => navigate("/topup")}>
                    TOP-UP
                  </Button>
                  <Button variant="danger" style={{ maxWidth: "250px" }} onClick={() => navigate("/withdraw")}>
                    WITHDRAW
                  </Button>
                </div>
              </div>
              {/* <Table
                striped
                bordered
                hover
                responsive
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th style={{ width: "12%" }}>Full Name</th>
                    <th style={{ width: "12%" }}>Email</th>
                    <th style={{ width: "12%" }}>Phone No.</th>
                    <th style={{ width: "12%" }}>DOB</th>
                    <th style={{ width: "20%" }}>Credits</th>
                    <th style={{ width: "15%" }}>Actions</th>
                  </tr>
                </thead>
                <tbody className="table-body">
                  <tr>
                    <td className="td1">{profileData.name}</td>
                    <td className="td1">{profileData.email}</td>
                    <td className="td1">{profileData.phone}</td>
                    <td className="td1">
                      {new Date(profileData.dob).toLocaleDateString("en-GB")}
                    </td>
                    <td className="td1">
                      {typeof profileData.credits === "number"
                        ? profileData.credits.toFixed(2)
                        : "0.00"}
                    </td>
                    <td
                      className="td1"
                      style={{ whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      <span
                        style={{
                          color: "#222",
                          fontWeight: "bold",
                          cursor: "pointer",
                          textDecoration: "underline",
                          marginRight: "10px",
                        }}
                        onClick={() => navigate("/topup")}
                      >
                        TOP-UP
                      </span>
                      <span style={{ fontWeight: "bold", margin: "0 5px" }}>
                        |
                      </span>
                      <span
                        style={{
                          color: "#222",
                          fontWeight: "bold",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => navigate("/withdraw")}
                      >
                        WITHDRAW
                      </span>
                    </td>
                  </tr>
                </tbody>
              </Table> */}
              <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Header
                  style={{
                    backgroundColor: "#333",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Modal.Title
                    style={{ color: "white", margin: 0, fontSize: "18px" }}
                  >
                    Edit Profile
                  </Modal.Title>
                  <div style={{ cursor: "pointer" }}>
                    <i
                      className="fa fa-times"
                      onClick={handleClose}
                      style={{ color: "#fff", fontSize: "20px" }}
                    ></i>
                  </div>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "white" }}>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formName">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </Form.Group>

                    <Form.Group controlId="formPassword">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="text"
                        name="password"
                        value={isEditing ? password : "******"}
                        onChange={handleInputChange}
                        isInvalid={!!passwordError}
                      />
                      <Form.Control.Feedback
                        type="invalid"
                        style={{ paddingLeft: "3%" }}
                      >
                        {passwordError}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="formEmail">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                    <Form.Group controlId="formPhone">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        maxlength="14"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                        inputmode="numeric"
                        value={formData.phone}
                        onChange={handleInputChange}
                        isInvalid={!!phoneError}
                      />
                      <Form.Control.Feedback
                        type="invalid"
                        style={{ paddingLeft: "3%" }}
                      >
                        {phoneError}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formDOB">
                      <Form.Label>Date of Birth</Form.Label>
                      <div
                        className={`datepicker-wrapper ${DobError ? "is-invalid" : ""
                          }`}
                      >
                        <DatePicker
                          selected={formData.dob}
                          onChange={(date) =>
                            setFormData({ ...formData, dob: date })
                          }
                          dateFormat="dd-MM-yyyy"
                          maxDate={new Date()}
                          showYearDropdown
                          scrollableYearDropdown
                          yearDropdownItemNumber={100}
                          placeholderText="Select DOB"
                          className={`form-control ${DobError ? "is-invalid" : ""
                            }`}
                        />
                      </div>
                      {DobError && (
                        <div
                          className="invalid-feedback"
                          style={{ paddingLeft: "3%" }}
                        >
                          {DobError}
                        </div>
                      )}
                    </Form.Group>

                    <div className="button-container">
                      <Button variant="primary" type="submit" className="btn5">
                        Save
                      </Button>
                    </div>
                  </Form>
                </Modal.Body>
              </Modal>

              {profileData.team && (
                <div className="mt-4 mb-5" style={{ height: "100%" }}>
                  <h5 className="mt-3">Players</h5>
                  <div>
                    <Table
                      striped
                      bordered
                      hover
                      responsive
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "20%" }}>Name</th>
                          <th style={{ width: "15%" }}>Purchase Value</th>
                          <th style={{ width: "15%" }}>Current Value</th>
                          <th style={{ width: "15%" }}>Share Quantity</th>
                          <th style={{ width: "15%" }}>Total Value</th>
                          <th style={{ width: "10%" }}>P/L Per Share</th>
                          <th style={{ width: "10%" }}>CURRENT TOTAL P/L</th>
                        </tr>
                      </thead>
                      <tbody>
                        {playersLoading ? (
                          <tr>
                            <td colSpan={7} style={{ textAlign: "center" }}>
                              <div
                                className="spinner-border mt-2"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) : !Array.isArray(players) || players.length === 0 ? (
                          <tr>
                            <td colSpan={7} style={{ textAlign: "center" }}>
                              <button
                                className="btn btn-primary"
                                onClick={() => navigate("/myteam")}
                                style={{
                                  margin: "16px 0",
                                  width: "200px",
                                  display: "inline-block",
                                }}
                              >
                                BUILD YOUR TEAM
                              </button>
                            </td>
                          </tr>
                        ) : (
                          players.map((player) => (
                            <PlayerRow
                              key={player._id}
                              player={player}
                              lifoLots={lifoLots}
                            />
                          ))
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            colSpan="4"
                            style={{ textAlign: "right", fontWeight: "bold" }}
                          ></td>
                          <td className="td1" style={{ fontWeight: "bold" }}>
                            {players
                              .reduce(
                                (sum, player) =>
                                  sum +
                                  (Number(player.currentValue) || 0) *
                                  (Number(player.share_quantity) || 0),
                                0
                              )
                              .toFixed(2)}
                          </td>
                          <td></td>
                          <td
                            className="td1"
                            style={{
                              fontWeight: "bold",
                              color:
                                tableTotalPL > 0
                                  ? "green"
                                  : tableTotalPL < 0
                                    ? "red"
                                    : "black",
                            }}
                          >
                            {tableTotalPL > 0
                              ? `+${tableTotalPL.toFixed(2)}`
                              : tableTotalPL.toFixed(2)}
                          </td>
                        </tr>
                      </tfoot>
                    </Table>
                  </div>
                </div>
              )}

              {profileData.team && (
                <div className="mt-4 " style={{ height: "100%" }}>
                  <h5 className="mt-3">History</h5>
                  <div>
                    <Table
                      striped
                      bordered
                      hover
                      responsive
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "14%" }}>DATE</th>
                          <th style={{ width: "14%" }}>TYPE</th>
                          <th style={{ width: "14%" }}>NAME</th>
                          <th style={{ width: "12%" }}>VALUE</th>
                          <th style={{ width: "12%" }}>BUY QTY</th>
                          <th style={{ width: "12%" }}>SELL QTY</th>
                          <th style={{ width: "12%" }}>TOTAL VALUE</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(Array.isArray(tradingHistory) ? tradingHistory : [])
                          .filter((tx) => Number(tx.quantity) > 0)
                          .sort((a, b) => new Date(b.date) - new Date(a.date))
                          .slice(
                            (currentPage - 1) * itemsPerPage,
                            currentPage * itemsPerPage
                          )
                          .map((tx, idx) => {
                            const date = tx.date
                              ? new Date(tx.date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              })
                              : "-";

                            const isPlayerTransaction =
                              tx.transaction_type === "player_transaction";
                            const displayType = tx.type
                              .replace(/_/g, " ")
                              .toUpperCase();
                            const displayName = tx.player_name || "-";
                            const displayValue = tx.value?.toFixed(2) || "-";
                            const displayBuyQty =
                              isPlayerTransaction && tx.type === "buy"
                                ? tx.quantity
                                : "-";
                            const displaySellQty =
                              isPlayerTransaction && tx.type === "sell"
                                ? tx.quantity
                                : "-";
                            const displayTotalValue = (
                              tx.total_value || 0
                            ).toFixed(2);

                            return (
                              <tr key={idx}>
                                <td>{date}</td>
                                <td>{displayType}</td>
                                <td>{displayName}</td>
                                <td>{displayValue}</td>
                                <td>{displayBuyQty}</td>
                                <td>{displaySellQty}</td>
                                <td>{displayTotalValue}</td>
                              </tr>
                            );
                          })}
                        {tradingHistory.length === 0 && (
                          <tr>
                            <td colSpan={7} style={{ textAlign: "center" }}>
                              <p>No History Found</p>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>

                    <div className="d-flex justify-content-center mt-3">
                      <nav>
                        <ul className="pagination">
                          <li
                            className={`page-item ${currentPage === 1 ? "disabled" : ""
                              }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                setCurrentPage((prev) => Math.max(prev - 1, 1))
                              }
                              disabled={currentPage === 1}
                            >
                              Previous
                            </button>
                          </li>
                          {[
                            ...Array(
                              Math.ceil(
                                (Array.isArray(tradingHistory)
                                  ? tradingHistory.filter(
                                    (tx) => Number(tx.quantity) > 0
                                  )
                                  : []
                                ).length / itemsPerPage
                              )
                            ),
                          ].map((_, index) => (
                            <li
                              key={index + 1}
                              className={`page-item ${currentPage === index + 1 ? "active" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(index + 1)}
                              >
                                {index + 1}
                              </button>
                            </li>
                          ))}
                          <li
                            className={`page-item ${currentPage ===
                              Math.ceil(
                                (Array.isArray(tradingHistory)
                                  ? tradingHistory.filter(
                                    (tx) => Number(tx.quantity) > 0
                                  )
                                  : []
                                ).length / itemsPerPage
                              )
                              ? "disabled"
                              : ""
                              }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                setCurrentPage((prev) =>
                                  Math.min(
                                    prev + 1,
                                    Math.ceil(
                                      (Array.isArray(tradingHistory)
                                        ? tradingHistory.filter(
                                          (tx) => Number(tx.quantity) > 0
                                        )
                                        : []
                                      ).length / itemsPerPage
                                    )
                                  )
                                )
                              }
                              disabled={
                                currentPage ===
                                Math.ceil(
                                  (Array.isArray(tradingHistory)
                                    ? tradingHistory.filter(
                                      (tx) => Number(tx.quantity) > 0
                                    )
                                    : []
                                  ).length / itemsPerPage
                                )
                              }
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
        <div className="card-footer3">
          <div className="footer">
            <div className="footer-firstline">
              <div className="footer-sub">
                <h4>Keep in touch</h4>
                <h5>Join our newsletter. We promise not to spam!</h5>
                <input
                  type="email"
                  placeholder="Email Address"
                  className="footer-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className="subscribe-btn" onClick={handleSubscribe}>
                  Subscribe
                </button>
                {message && (
                  <p style={{ marginTop: "10px", marginLeft: "5px" }}>
                    {message}
                  </p>
                )}
              </div>

              <div className="footer-sub1">
                <h4>Quick links</h4>
                <a href="/home" className="footer-link">
                  Home
                </a>
                <a href="/profile" className="footer-link">
                  Profile
                </a>
                <a href="/myteam" className="footer-link">
                  My Team
                </a>
                <a href="/news" className="footer-link">
                  News
                </a>
                <a href="/faq" className="footer-link">
                  FAQs
                </a>
              </div>

              <div className="footer-sub1 secondicon">
                <h4>Socials</h4>
                <div className="social-icons">
                  <a
                    href="https://www.facebook.com/toptennisio/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-circle"
                    style={{ textDecoration: "none" }}
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/toptennisuk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-circle"
                    style={{ textDecoration: "none" }}
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
                <div className="fl1">
                  <a
                    href="/terms"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    T&Cs
                  </a>
                  <a
                    href="/privacy"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                  <span className="footer-link">
                    Email: contact@toptennis.io
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}

export default ProfilePage;














// socket working properly but the refector is not applied
// import React, { useState, useEffect, useMemo, memo } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import axios from "axios";
// import Swal from "sweetalert2";
// import io from "socket.io-client";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Table,
//   Button,
//   Modal,
//   Offcanvas,
// } from "react-bootstrap";
// import "../Profile/profilepage.css";
// import { useNavigate } from "react-router-dom";

// // Memoized PlayerRow component to prevent unnecessary re-renders
// const PlayerRow = memo(({ player, lifoLots }) => {
//   const lots = lifoLots[player.name] || [];
//   // console.log(
//   //   `📋 Rendering player ${player.name} at ${new Date().toISOString()}:`,
//   //   JSON.stringify(
//   //     {
//   //       purchaseValue: player.value,
//   //       currentValue: player.currentValue,
//   //       shareQty: player.share_quantity,
//   //     },
//   //     null,
//   //     2
//   //   )
//   // );

//   if (lots.length === 0) {
//     const purchaseValue = Number(player.value) || 0;
//     const currentValue = Number(player.currentValue) || 0;
//     const shareQty = Number(player.share_quantity) || 0;
//     const totalValue = currentValue * shareQty;
//     const plPerShare = currentValue - purchaseValue;
//     const totalPL = plPerShare * shareQty;

//     return (
//       <tr key={player._id}>
//         <td style={{ width: "20%" }} className="td1">
//           {player.name || "N/A"}
//         </td>
//         <td style={{ width: "15%" }} className="td1">
//           {purchaseValue.toFixed(2)}
//         </td>
//         <td style={{ width: "15%" }} className="td1">
//           {currentValue.toFixed(2)}
//         </td>
//         <td style={{ width: "15%" }} className="td1">
//           {shareQty}
//         </td>
//         <td style={{ width: "15%" }} className="td1">
//           {totalValue.toFixed(2)}
//         </td>
//         <td
//           style={{
//             width: "10%",
//             color: plPerShare > 0 ? "green" : plPerShare < 0 ? "red" : "black",
//           }}
//           className="td1"
//         >
//           {plPerShare > 0 ? "+" : ""}
//           {plPerShare.toFixed(2)}
//         </td>
//         <td
//           style={{
//             width: "10%",
//             color: totalPL > 0 ? "green" : totalPL < 0 ? "red" : "black",
//           }}
//           className="td1"
//         >
//           {totalPL > 0 ? "+" : ""}
//           {totalPL.toFixed(2)}
//         </td>
//       </tr>
//     );
//   }

//   return lots.map((lot, idx) => {
//     const purchaseValue = Number(lot.price) || 0;
//     const currentValue = Number(player.currentValue) || 0;
//     const shareQty = Number(lot.qty) || 0;
//     const totalValue = currentValue * shareQty;
//     const plPerShare = currentValue - purchaseValue;
//     const totalPL = plPerShare * shareQty;

//     return (
//       <tr key={`${player._id}-lot-${idx}`}>
//         <td style={{ width: "20%" }} className="td1">
//           {player.name || "N/A"}
//         </td>
//         <td style={{ width: "15%" }} className="td1">
//           {purchaseValue.toFixed(2)}
//         </td>
//         <td style={{ width: "15%" }} className="td1">
//           {currentValue.toFixed(2)}
//         </td>
//         <td style={{ width: "15%" }} className="td1">
//           {shareQty}
//         </td>
//         <td style={{ width: "15%" }} className="td1">
//           {totalValue.toFixed(2)}
//         </td>
//         <td
//           style={{
//             width: "10%",
//             color: plPerShare > 0 ? "green" : plPerShare < 0 ? "red" : "black",
//           }}
//           className="td1"
//         >
//           {plPerShare > 0 ? "+" : ""}
//           {plPerShare.toFixed(2)}
//         </td>
//         <td
//           style={{
//             width: "10%",
//             color: totalPL > 0 ? "green" : totalPL < 0 ? "red" : "black",
//           }}
//           className="td1"
//         >
//           {totalPL > 0 ? "+" : ""}
//           {totalPL.toFixed(2)}
//         </td>
//       </tr>
//     );
//   });
// });

// function ProfilePage() {
//   const [profileData, setProfileData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     phone: "",
//     dob: "",
//     credits: "",
//     profile_image: "",
//     team: null,
//   });
//   const [totalDeposit, setTotalDeposit] = useState(0);
//   const [isMarketFrozen, setIsMarketFrozen] = useState(false);
//   const [freezeMessage, setFreezeMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [password, setPassword] = useState("");
//   const [phoneError, setPhoneError] = useState("");
//   const [playerval, setplayerval] = useState(0);
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [totalCreditFromApi, setTotalCreditFromApi] = useState(0);
//   const [playerLots, setPlayerLots] = useState({});
//   const [playersLoading, setPlayersLoading] = useState(true);
//   const [players, setPlayers] = useState([]);
//   const [inc, setInc] = useState(0);
//   const [prevIsMarketFrozen, setPrevIsMarketFrozen] = useState(isMarketFrozen);

//   const navigate = useNavigate();

//   // Initialize Socket.IO connection
//   const socket = useMemo(() => {
//     const socketInstance = io("https://toptennis.io", {
//       auth: {
//         token: localStorage.getItem("user_token"),
//       },
//     });
//     socketInstance.on("connect", () => {
//       console.log(`🔌 Socket connected`);
//     });
//     socketInstance.on("connect_error", (error) => {
//       console.error(`Socket connection error`, error.message);
//     });
//     socketInstance.on("disconnect", (reason) => {
//       console.log(`Socket disconnected`, reason);
//     });
//     return socketInstance;
//   }, []);

//   const fetchMarketStatus = async () => {
//     setIsLoading(true);
//     try {
//       const Token = localStorage.getItem("user_token");
//       const response = await axios.get(
//         "https://toptennis.io/api/users/market-status",
//         {
//           headers: { Authorization: `Bearer ${Token}` },
//         }
//       );
//       const { isFrozen, bannerText } = response.data;
//       setIsMarketFrozen(isFrozen);
//       setFreezeMessage(bannerText || "");
//       // console.log(`🔔 Market status fetched at ${new Date().toISOString()}:`, { isFrozen, bannerText });
//     } catch (error) {
//       console.error(`❌ Error fetching market status at ${new Date().toISOString()}:`, error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchMarketStatus();
//   }, []);

//   const showAutoError = (message) => {
//     Swal.fire({
//       position: "top-end",
//       icon: "error",
//       title: message,
//       showConfirmButton: false,
//       timer: 3000,
//     });
//   };

//   // Fetch initial player data and set up socket
//   useEffect(() => {
//     const fetchPlayersAndMergeData = async () => {
//       const Token = localStorage.getItem("user_token");
//       try {
//         const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//         const userId = decodedToken._id;
//         // console.log(`👤 Fetching initial data for user at ${new Date().toISOString()}:`, userId);

//         // Initial fetch
//         const response = await axios.get(
//           `https://toptennis.io/api/users/selected-teamlist/${userId}`,
//           { headers: { Authorization: `Bearer ${Token}` } }
//         );

//         // console.log(
//         //   `📥 Initial selected-teamlist response at ${new Date().toISOString()}:`,
//         //   JSON.stringify(response.data, null, 2)
//         // );

//         if (response.data && response.data.status) {
//           const { team, valueDifferences } = response.data;

//           const valueDifferenceMap = valueDifferences.reduce(
//             (acc, valueDifference) => {
//               acc[valueDifference.player_id] = valueDifference;
//               return acc;
//             },
//             {}
//           );

//           const mergedData = team.players.map((player) => {
//             const differenceData = valueDifferenceMap[player._id] || {};
//             return {
//               ...player,
//               currentValue: differenceData.value || player.value,
//               valueDifference: differenceData.valueDifference || 0,
//               latest_transaction_time: differenceData.latest_transaction_time || null,
//               buy_qty: differenceData.buy_qty,
//               sell_qty: differenceData.sell_qty,
//               last_buy_price: differenceData.last_buy_price,
//               last_buy_qty: differenceData.last_buy_qty,
//               share_quantity: differenceData.share_quantity || player.share_quantity || 0,
//               lastFreezePrice: player.lastFreezePrice || player.value,
//               lastFreezeShareQty: player.lastFreezeShareQty || player.share_quantity || 0,
//             };
//           });

//           // console.log(
//           //   `🟢 Setting initial players state at ${new Date().toISOString()}:`,
//           //   JSON.stringify(mergedData, null, 2)
//           // );
//           setPlayers(mergedData);

//           const lastChangedPlayer = mergedData.reduce((latest, player) => {
//             if (!latest) return player;
//             const latestTime = new Date(latest.latest_transaction_time || 0);
//             const playerTime = new Date(player.latest_transaction_time || 0);
//             return playerTime > latestTime ? player : latest;
//           }, null);

//           if (lastChangedPlayer) {
//             const calculatedInc =
//               (Number(lastChangedPlayer.valueDifference) || 0) *
//               (Number(lastChangedPlayer.share_quantity) || 0);
//             // console.log(
//             //   `🟢 Setting initial inc and playerval at ${new Date().toISOString()}:`,
//             //   calculatedInc,
//             //   "for player:",
//             //   lastChangedPlayer.name
//             // );
//             setplayerval(calculatedInc);
//             setInc(calculatedInc);
//           }
//         }
//       } catch (error) {
//         console.error(`❌ Error fetching initial data at ${new Date().toISOString()}:`, error.message);
//       } finally {
//         setPlayersLoading(false);
//         // console.log(`🟢 Players loading complete at ${new Date().toISOString()}`);
//       }
//     };

//     fetchPlayersAndMergeData();

//     // Join user room for Socket.IO updates
//     const Token = localStorage.getItem("user_token");
//     if (Token) {
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       socket.emit("joinUserRoom", decodedToken._id);
//       // console.log(`📤 Emitted joinUserRoom for user at ${new Date().toISOString()}:`, decodedToken._id);
//     }

//     // Listen for player updates
//     socket.on("playerUpdate", (data) => {
//       const startTime = new Date().toISOString();
//       // console.log(
//       //   `📥 Received playerUpdate from backend at ${startTime}:`,
//       //   JSON.stringify(data, null, 2)
//       // );

//       const { team, valueDifferences } = data;

//       if (!team || !Array.isArray(team.players) || !Array.isArray(valueDifferences)) {
//         console.error(
//           `❌ Invalid playerUpdate data structure at ${new Date().toISOString()}:`,
//           JSON.stringify(data, null, 2)
//         );
//         return;
//       }

//       const valueDifferenceMap = valueDifferences.reduce(
//         (acc, valueDifference) => {
//           acc[valueDifference.player_id] = valueDifference;
//           return acc;
//         },
//         {}
//       );

//       // console.log(
//       //   `🗺️ Value difference map at ${new Date().toISOString()}:`,
//       //   JSON.stringify(valueDifferenceMap, null, 2)
//       // );

//       setPlayers((prevPlayers) => {
//         const mergedData = prevPlayers.map((prevPlayer) => {
//           const teamPlayer = team.players.find((p) => p._id === prevPlayer._id);
//           const differenceData = valueDifferenceMap[prevPlayer._id] || {};

//           if (teamPlayer && differenceData.player_id) {
//             const updatedPlayer = {
//               ...prevPlayer,
//               currentValue: differenceData.value || prevPlayer.currentValue || prevPlayer.value,
//               valueDifference: differenceData.valueDifference || prevPlayer.valueDifference || 0,
//               latest_transaction_time: differenceData.latest_transaction_time || prevPlayer.latest_transaction_time || null,
//               buy_qty: differenceData.buy_qty || prevPlayer.buy_qty,
//               sell_qty: differenceData.sell_qty || prevPlayer.sell_qty,
//               last_buy_price: differenceData.last_buy_price || prevPlayer.last_buy_price,
//               last_buy_qty: differenceData.last_buy_qty || prevPlayer.last_buy_qty,
//               share_quantity: differenceData.share_quantity || teamPlayer.share_quantity || prevPlayer.share_quantity || 0,
//               lastFreezePrice: teamPlayer.lastFreezePrice || prevPlayer.lastFreezePrice || prevPlayer.value,
//               lastFreezeShareQty: teamPlayer.lastFreezeShareQty || prevPlayer.lastFreezeShareQty || prevPlayer.share_quantity || 0,
//             };
//             // console.log(
//             //   `🔄 Updated player ${prevPlayer.name} at ${new Date().toISOString()}:`,
//             //   JSON.stringify(updatedPlayer, null, 2)
//             // );
//             return updatedPlayer;
//           }
//           // console.log(
//           //   `🔄 Keeping unchanged player ${prevPlayer.name} at ${new Date().toISOString()}:`,
//           //   JSON.stringify(prevPlayer, null, 2)
//           // );
//           return prevPlayer;
//         });

//         // console.log(
//         //   `🟢 Updating players state with merged data at ${new Date().toISOString()}:`,
//         //   JSON.stringify(mergedData, null, 2)
//         // );

//         // Calculate inPlayValue (same as table's total current value)
//         const newInPlayValue = mergedData.reduce(
//           (sum, player) =>
//             sum + (Number(player.currentValue) || 0) * (Number(player.share_quantity) || 0),
//           0
//         );
//         setInPlayValue(newInPlayValue);
//         // console.log(
//         //   `🟢 Setting inPlayValue at ${new Date().toISOString()}:`,
//         //   newInPlayValue.toFixed(2)
//         // );

//         // Calculate differenceValue (same as tableTotalPL)
//         const newDifferenceValue = mergedData.reduce((total, player) => {
//           const lots = lifoLots[player.name] || [];
//           if (lots.length === 0) {
//             const purchaseValue = Number(player.value) || 0;
//             const currentValue = Number(player.currentValue) || 0;
//             const shareQty = Number(player.share_quantity) || 0;
//             const totalPL = (currentValue - purchaseValue) * shareQty;
//             return total + totalPL;
//           }
//           return lots.reduce((sum, lot) => {
//             const purchaseValue = Number(lot.price) || 0;
//             const currentValue = Number(player.currentValue) || 0;
//             const shareQty = Number(lot.qty) || 0;
//             const totalPL = (currentValue - purchaseValue) * shareQty;
//             return sum + totalPL;
//           }, total);
//         }, 0);
//         setDifferenceValue(newDifferenceValue);
//         // console.log(
//         //   `🟢 Setting differenceValue at ${new Date().toISOString()}:`,
//         //   newDifferenceValue.toFixed(2)
//         // );

//         return mergedData;
//       });

//       const lastChangedPlayer = valueDifferences.reduce((latest, diff) => {
//         const player = team.players.find((p) => p._id === diff.player_id);
//         if (!player) return latest;
//         if (!latest) return { ...player, ...diff };
//         const latestTime = new Date(latest.latest_transaction_time || 0);
//         const playerTime = new Date(diff.latest_transaction_time || 0);
//         return playerTime > latestTime ? { ...player, ...diff } : latest;
//       }, null);

//       if (lastChangedPlayer) {
//         const calculatedInc =
//           (Number(lastChangedPlayer.valueDifference) || 0) *
//           (Number(lastChangedPlayer.share_quantity) || 0);
//         // console.log(
//         //   `🟢 Setting inc and playerval at ${new Date().toISOString()}:`,
//         //   calculatedInc,
//         //   "for player:",
//         //   lastChangedPlayer.name
//         // );
//         setplayerval(calculatedInc);
//         setInc(calculatedInc);
//       } else {
//         console.log(`⚠️ No last changed player found for inc calculation at ${new Date().toISOString()}`);
//       }
//     });


//     // socket.on("playerUpdate", (data) => {
//     //   const startTime = new Date().toISOString();
//     //   console.log(
//     //     `📥 Received playerUpdate from backend at ${startTime}:`,
//     //     JSON.stringify(data, null, 2)
//     //   );

//     //   const { team, valueDifferences } = data;

//     //   if (!team || !Array.isArray(team.players) || !Array.isArray(valueDifferences)) {
//     //     console.error(
//     //       `❌ Invalid playerUpdate data structure at ${new Date().toISOString()}:`,
//     //       JSON.stringify(data, null, 2)
//     //     );
//     //     return;
//     //   }

//     //   const valueDifferenceMap = valueDifferences.reduce(
//     //     (acc, valueDifference) => {
//     //       acc[valueDifference.player_id] = valueDifference;
//     //       return acc;
//     //     },
//     //     {}
//     //   );

//     //   console.log(
//     //     `🗺️ Value difference map at ${new Date().toISOString()}:`,
//     //     JSON.stringify(valueDifferenceMap, null, 2)
//     //   );

//     //   setPlayers((prevPlayers) => {
//     //     const mergedData = prevPlayers.map((prevPlayer) => {
//     //       const teamPlayer = team.players.find((p) => p._id === prevPlayer._id);
//     //       const differenceData = valueDifferenceMap[prevPlayer._id] || {};

//     //       // If this player is in the update, use the new data; otherwise, keep existing
//     //       if (teamPlayer && differenceData.player_id) {
//     //         const updatedPlayer = {
//     //           ...prevPlayer,
//     //           currentValue: differenceData.value || prevPlayer.currentValue || prevPlayer.value,
//     //           valueDifference: differenceData.valueDifference || prevPlayer.valueDifference || 0,
//     //           latest_transaction_time: differenceData.latest_transaction_time || prevPlayer.latest_transaction_time || null,
//     //           buy_qty: differenceData.buy_qty || prevPlayer.buy_qty,
//     //           sell_qty: differenceData.sell_qty || prevPlayer.sell_qty,
//     //           last_buy_price: differenceData.last_buy_price || prevPlayer.last_buy_price,
//     //           last_buy_qty: differenceData.last_buy_qty || prevPlayer.last_buy_qty,
//     //           share_quantity: differenceData.share_quantity || teamPlayer.share_quantity || prevPlayer.share_quantity || 0,
//     //           lastFreezePrice: teamPlayer.lastFreezePrice || prevPlayer.lastFreezePrice || prevPlayer.value,
//     //           lastFreezeShareQty: teamPlayer.lastFreezeShareQty || prevPlayer.lastFreezeShareQty || prevPlayer.share_quantity || 0,
//     //         };
//     //         console.log(
//     //           `🔄 Updated player ${prevPlayer.name} at ${new Date().toISOString()}:`,
//     //           JSON.stringify(updatedPlayer, null, 2)
//     //         );
//     //         return updatedPlayer;
//     //       }
//     //       console.log(
//     //         `🔄 Keeping unchanged player ${prevPlayer.name} at ${new Date().toISOString()}:`,
//     //         JSON.stringify(prevPlayer, null, 2)
//     //       );
//     //       return prevPlayer;
//     //     });

//     //     console.log(
//     //       `🟢 Updating players state with merged data at ${new Date().toISOString()}:`,
//     //       JSON.stringify(mergedData, null, 2)
//     //     );
//     //     return mergedData;
//     //   });

//     //   const lastChangedPlayer = valueDifferences.reduce((latest, diff) => {
//     //     const player = team.players.find((p) => p._id === diff.player_id);
//     //     if (!player) return latest;
//     //     if (!latest) return { ...player, ...diff };
//     //     const latestTime = new Date(latest.latest_transaction_time || 0);
//     //     const playerTime = new Date(diff.latest_transaction_time || 0);
//     //     return playerTime > latestTime ? { ...player, ...diff } : latest;
//     //   }, null);

//     //   if (lastChangedPlayer) {
//     //     const calculatedInc =
//     //       (Number(lastChangedPlayer.valueDifference) || 0) *
//     //       (Number(lastChangedPlayer.share_quantity) || 0);
//     //     console.log(
//     //       `🟢 Setting inc and playerval at ${new Date().toISOString()}:`,
//     //       calculatedInc,
//     //       "for player:",
//     //       lastChangedPlayer.name
//     //     );
//     //     setplayerval(calculatedInc);
//     //     setInc(calculatedInc);
//     //   } else {
//     //     console.log(`⚠️ No last changed player found for inc calculation at ${new Date().toISOString()}`);
//     //   }
//     // });

//     // Cleanup socket on unmount

//     return () => {
//       console.log(`🧹 Disconnecting socket at ${new Date().toISOString()}`);
//       socket.disconnect();
//     };
//   }, [socket]);

//   useEffect(() => {
//     const fetchProfileData = async () => {
//       try {
//         const Token = localStorage.getItem("user_token");
//         const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//         const userId = decodedToken._id;

//         const response = await axios.get(
//           `https://toptennis.io/api/users/user/profile/${userId}`,
//           {
//             headers: { Authorization: `Bearer ${Token}` },
//           }
//         );

//         // console.log(
//         //   `📥 Profile data response at ${new Date().toISOString()}:`,
//         //   JSON.stringify(response.data, null, 2)
//         // );

//         if (response.data && response.data.userDetails) {
//           const {
//             name,
//             email,
//             password,
//             credits,
//             team,
//             profile_image,
//             phone,
//             dob,
//           } = response.data.userDetails;
//           setProfileData({
//             name: name || "",
//             email: email || "",
//             password: password || "",
//             phone: phone || "",
//             dob: dob || "",
//             credits: credits || "",
//             team: team || null,
//             profile_image: profile_image || "",
//           });
//           // console.log(
//           //   `🟢 Set profile data at ${new Date().toISOString()}:`,
//           //   JSON.stringify(
//           //     {
//           //       name,
//           //       email,
//           //       phone,
//           //       dob,
//           //       credits,
//           //       team,
//           //       profile_image,
//           //     },
//           //     null,
//           //     2
//           //   )
//           // );
//         }
//       } catch (error) {
//         console.error(`❌ Error fetching profile data at ${new Date().toISOString()}:`, error.message);
//         if (error.response) {
//           if (
//             error.response.status === 500 &&
//             error.response.data.message === "jwt expired"
//           ) {
//             showAutoError(error.response.data.message);
//           } else {
//             showAutoError("An error occurred while fetching profile data.");
//           }
//         }
//       }
//     };

//     fetchProfileData();
//   }, []);

//   const [showModal, setShowModal] = useState(false);
//   const [formData, setFormData] = useState({
//     name: profileData.name || "",
//     password: profileData.password || "",
//     email: profileData.email || "",
//     dob: profileData.dob || "",
//     phone: profileData.phone || "",
//   });
//   const [profileImage, setProfileImage] = useState(null);
//   const [passwordError, setPasswordError] = useState("");
//   const [DobError, setDobError] = useState("");
//   const formatDOBForInput = (dob) => {
//     if (!dob) return "";
//     const date = new Date(dob);
//     return date.toISOString().split("T")[0];
//   };

//   const handleEditClick = () => {
//     setFormData({
//       name: profileData.name,
//       password: profileData.password,
//       email: profileData.email,
//       phone: profileData.phone,
//       dob: formatDOBForInput(profileData.dob),
//     });
//     setShowModal(true);
//   };

//   const handleClose = () => setShowModal(false);
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "password") {
//       setIsEditing(true);
//       setPassword(value);
//       if (value.length > 12) {
//         setPasswordError("Maximum 12 characters.");
//       } else {
//         setPasswordError("");
//       }
//     }

//     if (name === "phone") {
//       const phoneRegex = /^[0-9]*$/;
//       if (value === "") {
//         setPhoneError("");
//       } else if (!phoneRegex.test(value)) {
//         setPhoneError("Only numeric values are allowed.");
//       } else if (value.length > 14) {
//         setPhoneError("Maximum 14 digits allowed.");
//       } else {
//         setPhoneError("");
//       }
//     }

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setProfileImage(file);
//     }
//   };

//   const isUnder18 = (dob) => {
//     const today = new Date();
//     const birthDate = new Date(dob);
//     const age = today.getFullYear() - birthDate.getFullYear();
//     const monthDiff = today.getMonth() - birthDate.getMonth();
//     const dayDiff = today.getDate() - birthDate.getDate();

//     if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
//       return age - 1 < 18;
//     }
//     return age < 18;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (formData.password.length > 12) {
//       setPasswordError("Password must be exactly 12 characters long.");
//       return;
//     }

//     const numericRegex = /^[0-9]{9,14}$/;
//     if (!numericRegex.test(formData.phone)) {
//       setPhoneError(
//         "Phone number must be 9 to 14 digits and contain only numbers."
//       );
//       return;
//     }

//     if (isUnder18(formData.dob)) {
//       setDobError("You must be at least 18 years old.");
//       return;
//     }

//     const result = await Swal.fire({
//       title: "Confirm Profile Update",
//       text: "You have changed your profile details. You will need to re-login. Continue?",
//       icon: "warning",
//       showDenyButton: true,
//       confirmButtonText: "Yes, update & logout",
//       denyButtonText: "No, keep existing",
//       buttonsStyling: false,
//       customClass: {
//         confirmButton: "btn btn-success me-2 btn-sm",
//         denyButton: "btn btn-danger me-2 btn-sm",
//         popup: "custom-popup",
//         closeButton: "custom-close-btn",
//       },
//       didOpen: () => {
//         const closeButton = document.querySelector(".swal2-close");
//         closeButton.classList.add("custom-close-btn");
//       },
//     });

//     if (result.isDenied || result.isDismissed) {
//       return;
//     }

//     try {
//       const Token = localStorage.getItem("user_token");
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       const userId = decodedToken._id;

//       const data = new FormData();
//       data.append("name", formData.name);
//       data.append("password", formData.password);
//       data.append("email", formData.email);
//       data.append("phone", formData.phone);
//       data.append("dob", formData.dob);
//       if (profileImage) {
//         data.append("profile_image", profileImage);
//       }

//       const response = await axios.patch(
//         `https://toptennis.io/api/users/userdetails-updated/${userId}`,
//         data,
//         {
//           headers: {
//             Authorization: `Bearer ${Token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       if (response.status === 201 || response.data.status) {
//         navigate("/");
//         setProfileData(response.data);
//         setShowModal(false);
//         localStorage.removeItem("user_token");
//         console.log(`🟢 Profile updated and user logged out at ${new Date().toISOString()}`);
//       }
//     } catch (error) {
//       console.error(`❌ Error updating user details at ${new Date().toISOString()}:`, error.message);
//       Swal.fire({
//         icon: "error",
//         title: "Update Failed",
//         text: error.response?.data?.message || "Something went wrong!",
//       });
//     }
//   };

//   const [show1, setShow1] = useState(false);
//   const [differenceValue, setDifferenceValue] = useState(0);
//   const [inPlayValue, setInPlayValue] = useState(0);
//   const [credits, setCredits] = useState(0);
//   const [userName, setUserName] = useState(0);
//   const [totalSpent, setTotalSpent] = useState(0);

//   const handleClose1 = () => setShow1(false);
//   const handleShow1 = () => setShow1(true);
//   const fetchUserValues = async () => {
//     const Token = localStorage.getItem("user_token");

//     if (Token) {
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       const userId = decodedToken._id;

//       try {
//         const response = await axios.get(
//           `https://toptennis.io/api/users/user/in-play-value/${userId}`,
//           {
//             headers: { Authorization: `Bearer ${Token}` },
//           }
//         );

//         // console.log(
//         //   `📥 In-play values response at ${new Date().toISOString()}:`,
//         //   JSON.stringify(response.data, null, 2)
//         // );

//         const {
//           name,
//           credits,
//           grand_total_value,
//           player_value_sum,
//           differenceValue,
//           latest_inc,
//           totalDeposit,
//         } = response.data;
//         setUserName(name);
//         setCredits(credits);
//         setInPlayValue(grand_total_value);
//         setTotalSpent(player_value_sum);
//         setDifferenceValue(differenceValue);
//         setplayerval(latest_inc);
//         setTotalCreditFromApi(totalDeposit || 0);
//         // console.log(
//         //   `🟢 Set user values at ${new Date().toISOString()}:`,
//         //   JSON.stringify(
//         //     {
//         //       name,
//         //       credits,
//         //       grand_total_value,
//         //       player_value_sum,
//         //       differenceValue,
//         //       latest_inc,
//         //       totalDeposit,
//         //     },
//         //     null,
//         //     2
//         //   )
//         // );
//       } catch (error) {
//         console.error(`❌ Error fetching in-play values at ${new Date().toISOString()}:`, error.message);
//       }
//     }
//   };

//   useEffect(() => {
//     fetchUserValues();
//   }, []);

//   const handleSubscribe = async () => {
//     if (!email) {
//       setMessage("Please enter a valid email.");
//       return;
//     }

//     try {
//       const response = await fetch(
//         "https://api.convertkit.com/v3/forms/7878458/subscribe",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             api_key: "3bkwOyREXJsvpFPZ5iUAAw",
//             email: email,
//           }),
//         }
//       );

//       const data = await response.json();
//       if (data.subscription) {
//         setMessage(
//           "Success! Please check your email to confirm your subscription."
//         );
//         setEmail("");
//       } else {
//         setMessage(data.message || "Something went wrong.");
//       }
//     } catch (error) {
//       setMessage("Subscription failed. Please try again later.");
//       console.error(`❌ Subscription error at ${new Date().toISOString()}:`, error.message);
//     }
//   };

//   const handleEmailClick = () => {
//     const email = "contact@toptennis.io";
//     const subject = "";
//     const body = "";
//     const url = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
//       subject
//     )}&body=${encodeURIComponent(body)}`;
//     window.open(url, "_blank");
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("user_token");
//     localStorage.removeItem("fullName");
//     localStorage.removeItem("userId");
//     localStorage.removeItem("user_isfrozen");
//     localStorage.removeItem("email");
//     console.log(`🟢 User logged out successfully at ${new Date().toISOString()}`);
//     navigate("/");
//   };

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   const [tradingHistory, setTradingHistory] = useState([]);

//   useEffect(() => {
//     const fetchTradingHistory = async () => {
//       const Token = localStorage.getItem("user_token");
//       if (!Token) return;
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       const userId = decodedToken._id;

//       try {
//         const response = await axios.get(
//           `https://toptennis.io/api/users/user/trading-history/${userId}`,
//           { headers: { Authorization: `Bearer ${Token}` } }
//         );
//         let history = [];
//         if (Array.isArray(response.data)) {
//           history = response.data;
//         } else if (Array.isArray(response.data.data)) {
//           history = response.data.data;
//         } else if (Array.isArray(response.data.history)) {
//           history = response.data.history;
//         } else if (Array.isArray(response.data.transactions)) {
//           history = response.data.transactions;
//         }
//         setTradingHistory(history);
//         // console.log(
//         //   `📥 Trading history response at ${new Date().toISOString()}:`,
//         //   JSON.stringify(history, null, 2)
//         // );

//         const lots = {};
//         if (Array.isArray(history)) {
//           history.forEach((tx) => {
//             if (!lots[tx.player_name]) lots[tx.player_name] = [];
//             if (tx.type === "buy") {
//               lots[tx.player_name].push({
//                 price: tx.value,
//                 qty: tx.quantity,
//                 type: "buy",
//                 timestamp: tx.date,
//               });
//             } else if (tx.type === "sell") {
//               lots[tx.player_name].push({
//                 price: tx.value,
//                 qty: tx.quantity,
//                 type: "sell",
//                 timestamp: tx.date,
//               });
//             }
//           });
//         }
//         setPlayerLots(lots);
//         // console.log(`🟢 Set player lots at ${new Date().toISOString()}:`, JSON.stringify(lots, null, 2));
//       } catch (error) {
//         console.error(`❌ Error fetching trading history at ${new Date().toISOString()}:`, error.message);
//       }
//     };

//     fetchTradingHistory();
//   }, []);

//   // Handle market freeze/unfreeze
//   useEffect(() => {
//     if (isMarketFrozen !== prevIsMarketFrozen) {
//       console.log(
//         `🔔 Market freeze state changed at ${new Date().toISOString()}:`,
//         prevIsMarketFrozen,
//         "->",
//         isMarketFrozen
//       );
//       if (isMarketFrozen === false) {
//         // Market just unfroze, reset lots
//         setPlayerLots({});
//         console.log(`🟢 Reset player lots on market unfreeze at ${new Date().toISOString()}`);
//       }

//       const prevFreezeData = getPrevFreezeData();
//       let incSum = 0;

//       setPlayers((prevPlayers) => {
//         const updatedPlayers = prevPlayers.map((player) => {
//           const prev = prevFreezeData[player._id];
//           let inc = 0;
//           if (prev) {
//             inc =
//               (player.currentValue - prev.lastFreezePrice) *
//               prev.lastFreezeShareQty;
//           }
//           incSum += inc;
//           const updatedPlayer = {
//             ...player,
//             lastFreezePrice: player.currentValue,
//             lastFreezeShareQty: player.share_quantity,
//             lastFreezeSellQty: player.sell_qty,
//           };
//           console.log(
//             `🔄 Updated player ${player.name} on freeze change at ${new Date().toISOString()}:`,
//             JSON.stringify(updatedPlayer, null, 2)
//           );
//           return updatedPlayer;
//         });

//         const newFreezeData = {};
//         updatedPlayers.forEach((player) => {
//           newFreezeData[player._id] = {
//             lastFreezePrice: player.currentValue,
//             lastFreezeShareQty: player.share_quantity,
//             lastFreezeSellQty: player.sell_qty,
//           };
//         });
//         setPrevFreezeData(newFreezeData);
//         console.log(
//           `🟢 Set prev freeze data at ${new Date().toISOString()}:`,
//           JSON.stringify(newFreezeData, null, 2)
//         );

//         setInc(incSum);
//         console.log(`🟢 Set inc on freeze change at ${new Date().toISOString()}:`, incSum);

//         return updatedPlayers;
//       });

//       setPrevIsMarketFrozen(isMarketFrozen);
//     }
//   }, [isMarketFrozen]);

//   const playerSummary = {};
//   if (Array.isArray(tradingHistory) && tradingHistory.length > 0) {
//     const lastBuyQtys = {};
//     const sortedHistory = [...tradingHistory].sort(
//       (a, b) => new Date(b.date) - new Date(a.date)
//     );

//     for (const tx of sortedHistory) {
//       if (
//         tx.type === "buy" &&
//         typeof lastBuyQtys[tx.player_name] === "undefined"
//       ) {
//         lastBuyQtys[tx.player_name] = tx.quantity;
//       }
//     }

//     tradingHistory.forEach((tx) => {
//       if (!playerSummary[tx.player_name]) {
//         playerSummary[tx.player_name] = {
//           name: tx.player_name,
//           totalBought: 0,
//           totalSpent: 0,
//           totalSold: 0,
//           totalReceived: 0,
//           transactions: [],
//           last_buy_qty: lastBuyQtys[tx.player_name] || 0,
//         };
//       }
//       if (tx.type === "buy") {
//         playerSummary[tx.player_name].totalBought += tx.quantity;
//         playerSummary[tx.player_name].totalSpent += tx.value * tx.quantity;
//       } else if (tx.type === "sell") {
//         playerSummary[tx.player_name].totalSold += tx.quantity;
//         playerSummary[tx.player_name].totalReceived += tx.value * tx.quantity;
//       }
//       playerSummary[tx.player_name].transactions.push(tx);
//     });
//   }

//   const totalCurrentPL = players.reduce((sum, player) => {
//     const summary = playerSummary[player.name] || {};
//     const tBought = summary.totalBought || 0;
//     const tSold = summary.totalSold || 0;
//     const tSpent = summary.totalSpent || 0;
//     const tReceived = summary.totalReceived || 0;
//     const avgBuy = tBought > 0 ? tSpent / tBought : 0;
//     const realized = tSold > 0 ? tReceived - avgBuy * tSold : 0;
//     const qty = player.share_quantity || 0;
//     const cValue = player.currentValue || 0;
//     const unrealized = qty > 0 ? (cValue - avgBuy) * qty : 0;
//     const tPL = realized + unrealized;
//     return sum + tPL;
//   }, 0);

//   const getPrevFreezeData = () =>
//     JSON.parse(localStorage.getItem("playerPrevFreezeData") || "{}");
//   const setPrevFreezeData = (data) =>
//     localStorage.setItem("playerPrevFreezeData", JSON.stringify(data));

//   const safeInc = typeof inc === "number" && !isNaN(inc) ? inc : 0;

//   function getLifoLots(tradingHistory, players) {
//     const playerLots = {};
//     players.forEach((player) => {
//       playerLots[player.name] = [];
//     });

//     const sortedHistory = [...tradingHistory].sort(
//       (a, b) => new Date(a.date) - new Date(b.date)
//     );

//     for (const tx of sortedHistory) {
//       if (!playerLots[tx.player_name]) playerLots[tx.player_name] = [];
//       if (tx.type === "buy") {
//         playerLots[tx.player_name].push({
//           price: tx.value,
//           qty: tx.quantity,
//           originalQty: tx.quantity,
//           date: tx.date,
//         });
//       } else if (tx.type === "sell") {
//         let qtyToSell = tx.quantity;
//         while (qtyToSell > 0 && playerLots[tx.player_name].length > 0) {
//           const lastLot =
//             playerLots[tx.player_name][playerLots[tx.player_name].length - 1];
//           if (lastLot.qty > qtyToSell) {
//             lastLot.qty -= qtyToSell;
//             qtyToSell = 0;
//           } else {
//             qtyToSell -= lastLot.qty;
//             playerLots[tx.player_name].pop();
//           }
//         }
//       }
//     }

//     Object.keys(playerLots).forEach((name) => {
//       playerLots[name] = playerLots[name].filter((lot) => lot.qty > 0);
//     });

//     return playerLots;
//   }

//   const lifoLots = useMemo(
//     () => getLifoLots(tradingHistory, players),
//     [tradingHistory, players]
//   );

//   const tableTotalPL = useMemo(() => {
//     const startTime = performance.now();
//     let total = 0;
//     players.forEach((player) => {
//       const lots = lifoLots[player.name] || [];
//       if (lots.length === 0) {
//         const purchaseValue = Number(player.value) || 0;
//         const currentValue = Number(player.currentValue) || 0;
//         const shareQty = Number(player.share_quantity) || 0;
//         const totalPL = (currentValue - purchaseValue) * shareQty;
//         total += totalPL;
//       } else {
//         lots.forEach((lot) => {
//           const purchaseValue = Number(lot.price) || 0;
//           const currentValue = Number(player.currentValue) || 0;
//           const shareQty = Number(lot.qty) || 0;
//           const totalPL = (currentValue - purchaseValue) * shareQty;
//           total += totalPL;
//         });
//       }
//     });
//     const endTime = performance.now();
//     // console.log(
//     //   `📊 Calculated tableTotalPL in ${(endTime - startTime).toFixed(2)}ms at ${new Date().toISOString()}:`,
//     //   total
//     // );
//     return total;
//   }, [players, lifoLots]);

//   // useEffect(() => {
//   //   console.log(
//   //     `🔄 Players state changed, triggering re-render at ${new Date().toISOString()}:`,
//   //     JSON.stringify(players, null, 2)
//   //   );
//   // }, [players]);

//   return (
//     <>
//       {isLoading && (
//         <div className="loader-overlay">
//           <div className="loader"></div>
//         </div>
//       )}
//       <Container className="justify-content-center align-items-center n-new cn">
//         <Row className="w-100 justify-content-center rowdiv">
//           <div className="freeze-banner">
//             <p>{freezeMessage} </p>
//           </div>

//           <div className="user-info">
//             <button
//               variant="light"
//               className="d-md-none menu-btn "
//               onClick={handleShow1}
//             >
//               ☰
//             </button>
//             <div className="left-section1 d-flex1">
//               <span className="welcome-text">Welcome, {userName}</span>
//               <div className="top-navigation d-none d-md-flex">
//                 <span className="nav-item" onClick={() => navigate("/home")}>
//                   Home
//                 </span>
//                 <span
//                   className="nav-item active"
//                   onClick={() => navigate("/profile")}
//                 >
//                   Profile
//                 </span>
//                 <span className="nav-item" onClick={() => navigate("/myteam")}>
//                   My Team
//                 </span>
//                 <span className="nav-item" onClick={() => navigate("/faq")}>
//                   FAQs
//                 </span>
//                 <span className="nav-item" onClick={() => navigate("/news")}>
//                   News
//                 </span>
//                 <span className="nav-item" onClick={handleLogout}>
//                   Logout
//                 </span>
//               </div>
//             </div>

//             <Offcanvas show={show1} onHide={handleClose1} placement="start">
//               <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>Menu</Offcanvas.Title>
//               </Offcanvas.Header>
//               <Offcanvas.Body>
//                 <div className="mobile-nav">
//                   <span
//                     className="nav-item "
//                     onClick={() => {
//                       navigate("/home");
//                       handleClose1();
//                     }}
//                   >
//                     Home
//                   </span>
//                   <span
//                     className="nav-item active"
//                     onClick={() => {
//                       navigate("/profile");
//                       handleClose1();
//                     }}
//                   >
//                     Profile
//                   </span>
//                   <span
//                     className="nav-item "
//                     onClick={() => {
//                       navigate("/myteam");
//                       handleClose1();
//                     }}
//                   >
//                     My Team
//                   </span>
//                   <span
//                     className="nav-item"
//                     onClick={() => {
//                       navigate("/faq");
//                       handleClose1();
//                     }}
//                   >
//                     FAQs
//                   </span>
//                   <span
//                     className="nav-item"
//                     onClick={() => {
//                       navigate("/news");
//                       handleClose1();
//                     }}
//                   >
//                     News
//                   </span>
//                   <span
//                     className="nav-item"
//                     onClick={() => {
//                       handleLogout();
//                       handleClose1();
//                     }}
//                   >
//                     Logout
//                   </span>
//                 </div>
//               </Offcanvas.Body>
//             </Offcanvas>

//             <div className="right-section1">
//               <div className="credit-box-container">
//                 <button
//                   className="topup-button"
//                   onClick={() => {
//                     navigate("/topup");
//                   }}
//                 >
//                   Top-up
//                 </button>
//                 <div className="credit-box">
//                   <p className="p">
//                     Credit available: <span>{credits?.toFixed(2)}</span>
//                   </p>
//                   <p className="p">
//                     In-play: <span>{inPlayValue.toFixed(2)}</span>
//                   </p>
//                   <p className="p">
//                     Current Team P/L:&nbsp;
//                     <span
//                       style={{
//                         color:
//                           Number(differenceValue) > 0
//                             ? "green"
//                             : Number(differenceValue) < 0
//                             ? "red"
//                             : "black",
//                       }}
//                     >
//                       {differenceValue
//                         ? Number(differenceValue) > 0
//                           ? `+${Number(differenceValue).toFixed(2)}`
//                           : Number(differenceValue).toFixed(2)
//                         : "0.00"}
//                     </span>
//                   </p>
//                   <button
//                     className="topup-button-mobile"
//                     onClick={() => {
//                       navigate("/topup");
//                     }}
//                   >
//                     Top-up
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <Col xs={12} sm={10} md={8}>
//             <div
//               style={{
//                 padding: "10px",
//                 background: "",
//                 borderRadius: "8px",
//                 boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
//                 height: "auto",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   marginBottom: "10px",
//                 }}
//               >
//                 <h3 style={{ margin: 0 }}>Profile Information</h3>
//                 <button
//                   onClick={handleEditClick}
//                   style={{
//                     color: "black",
//                     border: "none",
//                     borderRadius: "4px",
//                     padding: "6px 16px",
//                     fontWeight: "bold",
//                     cursor: "pointer",
//                     fontSize: "20px",
//                   }}
//                 >
//                   Edit Profile
//                 </button>
//               </div>
//               <Table
//                 striped
//                 bordered
//                 hover
//                 responsive
//                 style={{ width: "100%" }}
//               >
//                 <thead>
//                   <tr>
//                     <th style={{ width: "12%" }}>Full Name</th>
//                     <th style={{ width: "12%" }}>Email</th>
//                     <th style={{ width: "12%" }}>Phone No.</th>
//                     <th style={{ width: "12%" }}>DOB</th>
//                     <th style={{ width: "20%" }}>Credits</th>
//                     <th style={{ width: "15%" }}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="table-body">
//                   <tr>
//                     <td className="td1">{profileData.name}</td>
//                     <td className="td1">{profileData.email}</td>
//                     <td className="td1">{profileData.phone}</td>
//                     <td className="td1">
//                       {new Date(profileData.dob).toLocaleDateString("en-GB")}
//                     </td>
//                     <td className="td1">
//                       {typeof profileData.credits === "number"
//                         ? profileData.credits.toFixed(2)
//                         : "0.00"}
//                     </td>
//                     <td
//                       className="td1"
//                       style={{ whiteSpace: "nowrap", textAlign: "center" }}
//                     >
//                       <span
//                         style={{
//                           color: "#222",
//                           fontWeight: "bold",
//                           cursor: "pointer",
//                           textDecoration: "underline",
//                           marginRight: "10px",
//                         }}
//                         onClick={() => navigate("/topup")}
//                       >
//                         TOP-UP
//                       </span>
//                       <span style={{ fontWeight: "bold", margin: "0 5px" }}>
//                         |
//                       </span>
//                       <span
//                         style={{
//                           color: "#222",
//                           fontWeight: "bold",
//                           cursor: "pointer",
//                           textDecoration: "underline",
//                         }}
//                         onClick={() => navigate("/withdraw")}
//                       >
//                         WITHDRAW
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </Table>
//               <Modal show={showModal} onHide={handleClose} size="lg">
//                 <Modal.Header
//                   style={{
//                     backgroundColor: "#333",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <Modal.Title
//                     style={{ color: "white", margin: 0, fontSize: "18px" }}
//                   >
//                     Edit Profile
//                   </Modal.Title>
//                   <div style={{ cursor: "pointer" }}>
//                     <i
//                       className="fa fa-times"
//                       onClick={handleClose}
//                       style={{ color: "#fff", fontSize: "20px" }}
//                     ></i>
//                   </div>
//                 </Modal.Header>
//                 <Modal.Body style={{ backgroundColor: "white" }}>
//                   <Form onSubmit={handleSubmit}>
//                     <Form.Group controlId="formName">
//                       <Form.Label>Name</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="name"
//                         value={formData.name}
//                         onChange={handleInputChange}
//                         className="form-control"
//                       />
//                     </Form.Group>

//                     <Form.Group controlId="formPassword">
//                       <Form.Label>Password</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="password"
//                         value={isEditing ? password : "******"}
//                         onChange={handleInputChange}
//                         isInvalid={!!passwordError}
//                       />
//                       <Form.Control.Feedback
//                         type="invalid"
//                         style={{ paddingLeft: "3%" }}
//                       >
//                         {passwordError}
//                       </Form.Control.Feedback>
//                     </Form.Group>

//                     <Form.Group controlId="formEmail">
//                       <Form.Label>Email</Form.Label>
//                       <Form.Control
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleInputChange}
//                       />
//                     </Form.Group>
//                     <Form.Group controlId="formPhone">
//                       <Form.Label>Phone</Form.Label>
//                       <Form.Control
//                         type="tel"
//                         name="phone"
//                         maxlength="14"
//                         oninput="this.value = this.value.replace(/[^0-9]/g, '')"
//                         inputmode="numeric"
//                         value={formData.phone}
//                         onChange={handleInputChange}
//                         isInvalid={!!phoneError}
//                       />
//                       <Form.Control.Feedback
//                         type="invalid"
//                         style={{ paddingLeft: "3%" }}
//                       >
//                         {phoneError}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                     <Form.Group controlId="formDOB">
//                       <Form.Label>Date of Birth</Form.Label>
//                       <div
//                         className={`datepicker-wrapper ${
//                           DobError ? "is-invalid" : ""
//                         }`}
//                       >
//                         <DatePicker
//                           selected={formData.dob}
//                           onChange={(date) =>
//                             setFormData({ ...formData, dob: date })
//                           }
//                           dateFormat="dd-MM-yyyy"
//                           maxDate={new Date()}
//                           showYearDropdown
//                           scrollableYearDropdown
//                           yearDropdownItemNumber={100}
//                           placeholderText="Select DOB"
//                           className={`form-control ${
//                             DobError ? "is-invalid" : ""
//                           }`}
//                         />
//                       </div>
//                       {DobError && (
//                         <div
//                           className="invalid-feedback"
//                           style={{ paddingLeft: "3%" }}
//                         >
//                           {DobError}
//                         </div>
//                       )}
//                     </Form.Group>

//                     <div className="button-container">
//                       <Button variant="primary" type="submit" className="btn5">
//                         Save
//                       </Button>
//                     </div>
//                   </Form>
//                 </Modal.Body>
//               </Modal>

//               {profileData.team && (
//                 <div className="mt-4 mb-5" style={{ height: "100%" }}>
//                   <h5 className="mt-3">Players</h5>
//                   <div>
//                     <Table
//                       striped
//                       bordered
//                       hover
//                       responsive
//                       style={{ width: "100%" }}
//                     >
//                       <thead>
//                         <tr>
//                           <th style={{ width: "20%" }}>Name</th>
//                           <th style={{ width: "15%" }}>Purchase Value</th>
//                           <th style={{ width: "15%" }}>Current Value</th>
//                           <th style={{ width: "15%" }}>Share Quantity</th>
//                           <th style={{ width: "15%" }}>Total Value</th>
//                           <th style={{ width: "10%" }}>P/L Per Share</th>
//                           <th style={{ width: "10%" }}>CURRENT TOTAL P/L</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {playersLoading ? (
//                           <tr>
//                             <td colSpan={7} style={{ textAlign: "center" }}>
//                               <div
//                                 className="spinner-border mt-2"
//                                 role="status"
//                               >
//                                 <span className="visually-hidden">
//                                   Loading...
//                                 </span>
//                               </div>
//                             </td>
//                           </tr>
//                         ) : !Array.isArray(players) || players.length === 0 ? (
//                           <tr>
//                             <td colSpan={7} style={{ textAlign: "center" }}>
//                               <button
//                                 className="btn btn-primary"
//                                 onClick={() => navigate("/myteam")}
//                                 style={{
//                                   margin: "16px 0",
//                                   width: "200px",
//                                   display: "inline-block",
//                                 }}
//                               >
//                                 BUILD YOUR TEAM
//                               </button>
//                             </td>
//                           </tr>
//                         ) : (
//                           players.map((player) => (
//                             <PlayerRow
//                               key={player._id}
//                               player={player}
//                               lifoLots={lifoLots}
//                             />
//                           ))
//                         )}
//                       </tbody>
//                       <tfoot>
//                         <tr>
//                           <td
//                             colSpan="4"
//                             style={{ textAlign: "right", fontWeight: "bold" }}
//                           ></td>
//                           <td className="td1" style={{ fontWeight: "bold" }}>
//                             {players
//                               .reduce(
//                                 (sum, player) =>
//                                   sum +
//                                   (Number(player.currentValue) || 0) *
//                                     (Number(player.share_quantity) || 0),
//                                 0
//                               )
//                               .toFixed(2)}
//                           </td>
//                           <td></td>
//                           <td
//                             className="td1"
//                             style={{
//                               fontWeight: "bold",
//                               color:
//                                 tableTotalPL > 0
//                                   ? "green"
//                                   : tableTotalPL < 0
//                                   ? "red"
//                                   : "black",
//                             }}
//                           >
//                             {tableTotalPL > 0
//                               ? `+${tableTotalPL.toFixed(2)}`
//                               : tableTotalPL.toFixed(2)}
//                           </td>
//                         </tr>
//                       </tfoot>
//                     </Table>
//                   </div>
//                 </div>
//               )}

//               {profileData.team && (
//                 <div className="mt-4 mb-5" style={{ height: "100%" }}>
//                   <h5 className="mt-3">History</h5>
//                   <div>
//                     <Table
//                       striped
//                       bordered
//                       hover
//                       responsive
//                       style={{ width: "100%" }}
//                     >
//                       <thead>
//                         <tr>
//                           <th style={{ width: "14%" }}>DATE</th>
//                           <th style={{ width: "14%" }}>TYPE</th>
//                           <th style={{ width: "14%" }}>NAME</th>
//                           <th style={{ width: "12%" }}>VALUE</th>
//                           <th style={{ width: "12%" }}>BUY QTY</th>
//                           <th style={{ width: "12%" }}>SELL QTY</th>
//                           <th style={{ width: "12%" }}>TOTAL VALUE</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {(Array.isArray(tradingHistory) ? tradingHistory : [])
//                           .filter((tx) => Number(tx.quantity) > 0)
//                           .sort((a, b) => new Date(b.date) - new Date(a.date))
//                           .slice(
//                             (currentPage - 1) * itemsPerPage,
//                             currentPage * itemsPerPage
//                           )
//                           .map((tx, idx) => {
//                             const date = tx.date
//                               ? new Date(tx.date).toLocaleDateString("en-GB", {
//                                   day: "2-digit",
//                                   month: "2-digit",
//                                   year: "numeric",
//                                 })
//                               : "-";

//                             const isPlayerTransaction =
//                               tx.transaction_type === "player_transaction";
//                             const displayType = tx.type
//                               .replace(/_/g, " ")
//                               .toUpperCase();
//                             const displayName = tx.player_name || "-";
//                             const displayValue = tx.value?.toFixed(2) || "-";
//                             const displayBuyQty =
//                               isPlayerTransaction && tx.type === "buy"
//                                 ? tx.quantity
//                                 : "-";
//                             const displaySellQty =
//                               isPlayerTransaction && tx.type === "sell"
//                                 ? tx.quantity
//                                 : "-";
//                             const displayTotalValue = (
//                               tx.total_value || 0
//                             ).toFixed(2);

//                             return (
//                               <tr key={idx}>
//                                 <td>{date}</td>
//                                 <td>{displayType}</td>
//                                 <td>{displayName}</td>
//                                 <td>{displayValue}</td>
//                                 <td>{displayBuyQty}</td>
//                                 <td>{displaySellQty}</td>
//                                 <td>{displayTotalValue}</td>
//                               </tr>
//                             );
//                           })}
//                         {tradingHistory.length === 0 && (
//                           <tr>
//                             <td colSpan={7} style={{ textAlign: "center" }}>
//                               <p>No History Found</p>
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </Table>

//                     <div className="d-flex justify-content-center mt-3">
//                       <nav>
//                         <ul className="pagination">
//                           <li
//                             className={`page-item ${
//                               currentPage === 1 ? "disabled" : ""
//                             }`}
//                           >
//                             <button
//                               className="page-link"
//                               onClick={() =>
//                                 setCurrentPage((prev) => Math.max(prev - 1, 1))
//                               }
//                               disabled={currentPage === 1}
//                             >
//                               Previous
//                             </button>
//                           </li>
//                           {[
//                             ...Array(
//                               Math.ceil(
//                                 (Array.isArray(tradingHistory)
//                                   ? tradingHistory.filter(
//                                       (tx) => Number(tx.quantity) > 0
//                                     )
//                                   : []
//                                 ).length / itemsPerPage
//                               )
//                             ),
//                           ].map((_, index) => (
//                             <li
//                               key={index + 1}
//                               className={`page-item ${
//                                 currentPage === index + 1 ? "active" : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() => setCurrentPage(index + 1)}
//                               >
//                                 {index + 1}
//                               </button>
//                             </li>
//                           ))}
//                           <li
//                             className={`page-item ${
//                               currentPage ===
//                               Math.ceil(
//                                 (Array.isArray(tradingHistory)
//                                   ? tradingHistory.filter(
//                                       (tx) => Number(tx.quantity) > 0
//                                       )
//                                   : []
//                                 ).length / itemsPerPage
//                               )
//                                 ? "disabled"
//                                 : ""
//                             }`}
//                           >
//                             <button
//                               className="page-link"
//                               onClick={() =>
//                                 setCurrentPage((prev) =>
//                                   Math.min(
//                                     prev + 1,
//                                     Math.ceil(
//                                       (Array.isArray(tradingHistory)
//                                         ? tradingHistory.filter(
//                                             (tx) => Number(tx.quantity) > 0
//                                           )
//                                         : []
//                                       ).length / itemsPerPage
//                                     )
//                                   )
//                                 )
//                               }
//                               disabled={
//                                 currentPage ===
//                                 Math.ceil(
//                                   (Array.isArray(tradingHistory)
//                                     ? tradingHistory.filter(
//                                         (tx) => Number(tx.quantity) > 0
//                                       )
//                                     : []
//                                   ).length / itemsPerPage
//                                 )
//                               }
//                             >
//                               Next
//                             </button>
//                           </li>
//                         </ul>
//                       </nav>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </Col>
//         </Row>
//         <div className="card-footer3">
//           <div className="footer">
//             <div className="footer-firstline">
//               <div className="footer-sub">
//                 <h4>Keep in touch</h4>
//                 <h5>Join our newsletter. We promise not to spam!</h5>
//                 <input
//                   type="email"
//                   placeholder="Email Address"
//                   className="footer-input"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//                 <button className="subscribe-btn" onClick={handleSubscribe}>
//                   Subscribe
//                 </button>
//                 {message && (
//                   <p style={{ marginTop: "10px", marginLeft: "5px" }}>
//                     {message}
//                   </p>
//                 )}
//               </div>

//               <div className="footer-sub1">
//                 <h4>Quick links</h4>
//                 <a href="/home" className="footer-link">
//                   Home
//                 </a>
//                 <a href="/profile" className="footer-link">
//                   Profile
//                 </a>
//                 <a href="/myteam" className="footer-link">
//                   My Team
//                 </a>
//                 <a href="/news" className="footer-link">
//                   News
//                 </a>
//                 <a href="/faq" className="footer-link">
//                   FAQs
//                 </a>
//               </div>

//               <div className="footer-sub1 secondicon">
//                 <h4>Socials</h4>
//                 <div className="social-icons">
//                   <a
//                     href="https://www.facebook.com/toptennisio/"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="social-circle"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <i className="fab fa-facebook-f"></i>
//                   </a>
//                   <a
//                     href="https://www.instagram.com/toptennisuk"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="social-circle"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <i className="fab fa-instagram"></i>
//                   </a>
//                 </div>
//                 <div className="fl1">
//                   <a
//                     href="/terms"
//                     className="footer-link"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     T&Cs
//                   </a>
//                   <a
//                     href="/privacy"
//                     className="footer-link"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     Privacy Policy
//                   </a>
//                   <span className="footer-link">
//                     Email: contact@toptennis.io
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Container>
//     </>
//   );
// }

// export default ProfilePage;















// socket working with 2 second delay
// import React, { useState, useEffect, useMemo } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import axios from "axios";
// import Swal from "sweetalert2";
// import io from "socket.io-client";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Table,
//   Button,
//   Modal,
//   Offcanvas,
// } from "react-bootstrap";
// import "../Profile/profilepage.css";
// import { useNavigate } from "react-router-dom";

// function ProfilePage() {
//   const [profileData, setProfileData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     phone: "",
//     dob: "",
//     credits: "",
//     profile_image: "",
//     team: null,
//   });
//   const [totalDeposit, setTotalDeposit] = useState(0);
//   const [isMarketFrozen, setIsMarketFrozen] = useState(false);
//   const [freezeMessage, setFreezeMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [password, setPassword] = useState("");
//   const [phoneError, setPhoneError] = useState("");
//   const [playerval, setplayerval] = useState(0);
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [totalCreditFromApi, setTotalCreditFromApi] = useState(0);
//   const [playerLots, setPlayerLots] = useState({});
//   const [playersLoading, setPlayersLoading] = useState(true);
//   const [players, setPlayers] = useState([]);
//   const [inc, setInc] = useState(0);
//   const [prevIsMarketFrozen, setPrevIsMarketFrozen] = useState(isMarketFrozen);

//   const navigate = useNavigate();

//   // Initialize Socket.IO connection
//   const socket = useMemo(() => {
//     const socketInstance = io("https://toptennis.io", {
//       auth: {
//         token: localStorage.getItem("user_token"),
//       },
//     });
//     socketInstance.on("connect", () => {
//       console.log("🔌 Socket connected:", socketInstance.id);
//     });
//     socketInstance.on("connect_error", (error) => {
//       console.error("❌ Socket connection error:", error.message);
//     });
//     socketInstance.on("disconnect", (reason) => {
//       console.log("❌ Socket disconnected:", reason);
//     });
//     return socketInstance;
//   }, []);

//   const fetchMarketStatus = async () => {
//     setIsLoading(true);
//     try {
//       const Token = localStorage.getItem("user_token");
//       const response = await axios.get(
//         "https://toptennis.io/api/users/market-status",
//         {
//           headers: { Authorization: `Bearer ${Token}` },
//         }
//       );
//       const { isFrozen, bannerText } = response.data;
//       setIsMarketFrozen(isFrozen);
//       setFreezeMessage(bannerText || "");
//       console.log("🔔 Market status fetched:", { isFrozen, bannerText });
//     } catch (error) {
//       console.error("❌ Error fetching market status:", error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchMarketStatus();
//   }, []);

//   const showAutoError = (message) => {
//     Swal.fire({
//       position: "top-end",
//       icon: "error",
//       title: message,
//       showConfirmButton: false,
//       timer: 3000,
//     });
//   };

//   // Fetch initial player data and set up socket
//   useEffect(() => {
//     const fetchPlayersAndMergeData = async () => {
//       const Token = localStorage.getItem("user_token");
//       try {
//         const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//         const userId = decodedToken._id;
//         console.log("👤 Fetching initial data for user:", userId);

//         // Initial fetch
//         const response = await axios.get(
//           `https://toptennis.io/api/users/selected-teamlist/${userId}`,
//           { headers: { Authorization: `Bearer ${Token}` } }
//         );

//         console.log(
//           "📥 Initial selected-teamlist response:",
//           JSON.stringify(response.data, null, 2)
//         );

//         if (response.data && response.data.status) {
//           const { team, valueDifferences } = response.data;

//           const valueDifferenceMap = valueDifferences.reduce(
//             (acc, valueDifference) => {
//               acc[valueDifference.player_id] = valueDifference;
//               return acc;
//             },
//             {}
//           );

//           const mergedData = team.players.map((player) => {
//             const differenceData = valueDifferenceMap[player._id] || {};
//             return {
//               ...player,
//               currentValue: differenceData.value || player.value,
//               valueDifference: differenceData.valueDifference || 0,
//               latest_transaction_time: differenceData.latest_transaction_time || null,
//               buy_qty: differenceData.buy_qty,
//               sell_qty: differenceData.sell_qty,
//               last_buy_price: differenceData.last_buy_price,
//               last_buy_qty: differenceData.last_buy_qty,
//               share_quantity: differenceData.share_quantity || player.share_quantity || 0,
//               lastFreezePrice: player.lastFreezePrice || player.value,
//               lastFreezeShareQty: player.lastFreezeShareQty || player.share_quantity || 0,
//             };
//           });

//           console.log(
//             "🟢 Setting initial players state:",
//             JSON.stringify(mergedData, null, 2)
//           );
//           setPlayers(mergedData);

//           const lastChangedPlayer = mergedData.reduce((latest, player) => {
//             if (!latest) return player;
//             const latestTime = new Date(latest.latest_transaction_time || 0);
//             const playerTime = new Date(player.latest_transaction_time || 0);
//             return playerTime > latestTime ? player : latest;
//           }, null);

//           if (lastChangedPlayer) {
//             const calculatedInc =
//               (Number(lastChangedPlayer.valueDifference) || 0) *
//               (Number(lastChangedPlayer.share_quantity) || 0);
//             console.log(
//               "🟢 Setting initial inc and playerval:",
//               calculatedInc,
//               "for player:",
//               lastChangedPlayer.name
//             );
//             setplayerval(calculatedInc);
//             setInc(calculatedInc);
//           }
//         }
//       } catch (error) {
//         console.error("❌ Error fetching initial data:", error.message);
//       } finally {
//         setPlayersLoading(false);
//         console.log("🟢 Players loading complete");
//       }
//     };

//     fetchPlayersAndMergeData();

//     // Join user room for Socket.IO updates
//     const Token = localStorage.getItem("user_token");
//     if (Token) {
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       socket.emit("joinUserRoom", decodedToken._id);
//       console.log("📤 Emitted joinUserRoom for user:", decodedToken._id);
//     }

//     // Listen for player updates
//     socket.on("playerUpdate", (data) => {
//       console.log(
//         "📥 Received playerUpdate from backend:",
//         JSON.stringify(data, null, 2)
//       );

//       const { team, valueDifferences } = data;

//       if (!team || !Array.isArray(team.players) || !Array.isArray(valueDifferences)) {
//         console.error(
//           "❌ Invalid playerUpdate data structure:",
//           JSON.stringify(data, null, 2)
//         );
//         return;
//       }

//       const valueDifferenceMap = valueDifferences.reduce(
//         (acc, valueDifference) => {
//           acc[valueDifference.player_id] = valueDifference;
//           return acc;
//         },
//         {}
//       );

//       console.log(
//         "🗺️ Value difference map:",
//         JSON.stringify(valueDifferenceMap, null, 2)
//       );

//       setPlayers((prevPlayers) => {
//         const mergedData = prevPlayers.map((prevPlayer) => {
//           const teamPlayer = team.players.find((p) => p._id === prevPlayer._id);
//           const differenceData = valueDifferenceMap[prevPlayer._id] || {};

//           // If this player is in the update, use the new data; otherwise, keep existing
//           if (teamPlayer && differenceData.player_id) {
//             const updatedPlayer = {
//               ...prevPlayer,
//               currentValue: differenceData.value || prevPlayer.currentValue || prevPlayer.value,
//               valueDifference: differenceData.valueDifference || prevPlayer.valueDifference || 0,
//               latest_transaction_time: differenceData.latest_transaction_time || prevPlayer.latest_transaction_time || null,
//               buy_qty: differenceData.buy_qty || prevPlayer.buy_qty,
//               sell_qty: differenceData.sell_qty || prevPlayer.sell_qty,
//               last_buy_price: differenceData.last_buy_price || prevPlayer.last_buy_price,
//               last_buy_qty: differenceData.last_buy_qty || prevPlayer.last_buy_qty,
//               share_quantity: differenceData.share_quantity || teamPlayer.share_quantity || prevPlayer.share_quantity || 0,
//               lastFreezePrice: teamPlayer.lastFreezePrice || prevPlayer.lastFreezePrice || prevPlayer.value,
//               lastFreezeShareQty: teamPlayer.lastFreezeShareQty || prevPlayer.lastFreezeShareQty || prevPlayer.share_quantity || 0,
//             };
//             console.log(
//               `🔄 Updated player ${prevPlayer.name}:`,
//               JSON.stringify(updatedPlayer, null, 2)
//             );
//             return updatedPlayer;
//           }
//           // Keep existing player data unchanged
//           console.log(
//             `🔄 Keeping unchanged player ${prevPlayer.name}:`,
//             JSON.stringify(prevPlayer, null, 2)
//           );
//           return prevPlayer;
//         });

//         console.log(
//           "🟢 Updating players state with merged data:",
//           JSON.stringify(mergedData, null, 2)
//         );
//         return mergedData;
//       });

//       const lastChangedPlayer = valueDifferences.reduce((latest, diff) => {
//         const player = team.players.find((p) => p._id === diff.player_id);
//         if (!player) return latest;
//         if (!latest) return { ...player, ...diff };
//         const latestTime = new Date(latest.latest_transaction_time || 0);
//         const playerTime = new Date(diff.latest_transaction_time || 0);
//         return playerTime > latestTime ? { ...player, ...diff } : latest;
//       }, null);

//       if (lastChangedPlayer) {
//         const calculatedInc =
//           (Number(lastChangedPlayer.valueDifference) || 0) *
//           (Number(lastChangedPlayer.share_quantity) || 0);
//         console.log(
//           "🟢 Setting inc and playerval:",
//           calculatedInc,
//           "for player:",
//           lastChangedPlayer.name
//         );
//         setplayerval(calculatedInc);
//         setInc(calculatedInc);
//       } else {
//         console.log("⚠️ No last changed player found for inc calculation");
//       }
//     });

//     // Cleanup socket on unmount
//     return () => {
//       console.log("🧹 Disconnecting socket");
//       socket.disconnect();
//     };
//   }, [socket]);

//   useEffect(() => {
//     const fetchProfileData = async () => {
//       try {
//         const Token = localStorage.getItem("user_token");
//         const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//         const userId = decodedToken._id;

//         const response = await axios.get(
//           `https://toptennis.io/api/users/user/profile/${userId}`,
//           {
//             headers: { Authorization: `Bearer ${Token}` },
//           }
//         );

//         console.log(
//           "📥 Profile data response:",
//           JSON.stringify(response.data, null, 2)
//         );

//         if (response.data && response.data.userDetails) {
//           const {
//             name,
//             email,
//             password,
//             credits,
//             team,
//             profile_image,
//             phone,
//             dob,
//           } = response.data.userDetails;
//           setProfileData({
//             name: name || "",
//             email: email || "",
//             password: password || "",
//             phone: phone || "",
//             dob: dob || "",
//             credits: credits || "",
//             team: team || null,
//             profile_image: profile_image || "",
//           });
//           console.log(
//             "🟢 Set profile data:",
//             JSON.stringify(
//               {
//                 name,
//                 email,
//                 phone,
//                 dob,
//                 credits,
//                 team,
//                 profile_image,
//               },
//               null,
//               2
//             )
//           );
//         }
//       } catch (error) {
//         console.error("❌ Error fetching profile data:", error.message);
//         if (error.response) {
//           if (
//             error.response.status === 500 &&
//             error.response.data.message === "jwt expired"
//           ) {
//             showAutoError(error.response.data.message);
//           } else {
//             showAutoError("An error occurred while fetching profile data.");
//           }
//         }
//       }
//     };

//     fetchProfileData();
//   }, []);

//   const [showModal, setShowModal] = useState(false);
//   const [formData, setFormData] = useState({
//     name: profileData.name || "",
//     password: profileData.password || "",
//     email: profileData.email || "",
//     dob: profileData.dob || "",
//     phone: profileData.phone || "",
//   });
//   const [profileImage, setProfileImage] = useState(null);
//   const [passwordError, setPasswordError] = useState("");
//   const [DobError, setDobError] = useState("");
//   const formatDOBForInput = (dob) => {
//     if (!dob) return "";
//     const date = new Date(dob);
//     return date.toISOString().split("T")[0];
//   };

//   const handleEditClick = () => {
//     setFormData({
//       name: profileData.name,
//       password: profileData.password,
//       email: profileData.email,
//       phone: profileData.phone,
//       dob: formatDOBForInput(profileData.dob),
//     });
//     setShowModal(true);
//   };

//   const handleClose = () => setShowModal(false);
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "password") {
//       setIsEditing(true);
//       setPassword(value);
//       if (value.length > 12) {
//         setPasswordError("Maximum 12 characters.");
//       } else {
//         setPasswordError("");
//       }
//     }

//     if (name === "phone") {
//       const phoneRegex = /^[0-9]*$/;
//       if (value === "") {
//         setPhoneError("");
//       } else if (!phoneRegex.test(value)) {
//         setPhoneError("Only numeric values are allowed.");
//       } else if (value.length > 14) {
//         setPhoneError("Maximum 14 digits allowed.");
//       } else {
//         setPhoneError("");
//       }
//     }

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setProfileImage(file);
//     }
//   };

//   const isUnder18 = (dob) => {
//     const today = new Date();
//     const birthDate = new Date(dob);
//     const age = today.getFullYear() - birthDate.getFullYear();
//     const monthDiff = today.getMonth() - birthDate.getMonth();
//     const dayDiff = today.getDate() - birthDate.getDate();

//     if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
//       return age - 1 < 18;
//     }
//     return age < 18;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (formData.password.length > 12) {
//       setPasswordError("Password must be exactly 12 characters long.");
//       return;
//     }

//     const numericRegex = /^[0-9]{9,14}$/;
//     if (!numericRegex.test(formData.phone)) {
//       setPhoneError(
//         "Phone number must be 9 to 14 digits and contain only numbers."
//       );
//       return;
//     }

//     if (isUnder18(formData.dob)) {
//       setDobError("You must be at least 18 years old.");
//       return;
//     }

//     const result = await Swal.fire({
//       title: "Confirm Profile Update",
//       text: "You have changed your profile details. You will need to re-login. Continue?",
//       icon: "warning",
//       showDenyButton: true,
//       confirmButtonText: "Yes, update & logout",
//       denyButtonText: "No, keep existing",
//       buttonsStyling: false,
//       customClass: {
//         confirmButton: "btn btn-success me-2 btn-sm",
//         denyButton: "btn btn-danger me-2 btn-sm",
//         popup: "custom-popup",
//         closeButton: "custom-close-btn",
//       },
//       didOpen: () => {
//         const closeButton = document.querySelector(".swal2-close");
//         closeButton.classList.add("custom-close-btn");
//       },
//     });

//     if (result.isDenied || result.isDismissed) {
//       return;
//     }

//     try {
//       const Token = localStorage.getItem("user_token");
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       const userId = decodedToken._id;

//       const data = new FormData();
//       data.append("name", formData.name);
//       data.append("password", formData.password);
//       data.append("email", formData.email);
//       data.append("phone", formData.phone);
//       data.append("dob", formData.dob);
//       if (profileImage) {
//         data.append("profile_image", profileImage);
//       }

//       const response = await axios.patch(
//         `https://toptennis.io/api/users/userdetails-updated/${userId}`,
//         data,
//         {
//           headers: {
//             Authorization: `Bearer ${Token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       if (response.status === 201 || response.data.status) {
//         navigate("/");
//         setProfileData(response.data);
//         setShowModal(false);
//         localStorage.removeItem("user_token");
//         console.log("🟢 Profile updated and user logged out");
//       }
//     } catch (error) {
//       console.error("❌ Error updating user details:", error.message);
//       Swal.fire({
//         icon: "error",
//         title: "Update Failed",
//         text: error.response?.data?.message || "Something went wrong!",
//       });
//     }
//   };

//   const [show1, setShow1] = useState(false);
//   const [differenceValue, setDifferenceValue] = useState(0);
//   const [inPlayValue, setInPlayValue] = useState(0);
//   const [credits, setCredits] = useState(0);
//   const [userName, setUserName] = useState(0);
//   const [totalSpent, setTotalSpent] = useState(0);

//   const handleClose1 = () => setShow1(false);
//   const handleShow1 = () => setShow1(true);
//   const fetchUserValues = async () => {
//     const Token = localStorage.getItem("user_token");

//     if (Token) {
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       const userId = decodedToken._id;

//       try {
//         const response = await axios.get(
//           `https://toptennis.io/api/users/user/in-play-value/${userId}`,
//           {
//             headers: { Authorization: `Bearer ${Token}` },
//           }
//         );

//         console.log(
//           "📥 In-play values response:",
//           JSON.stringify(response.data, null, 2)
//         );

//         const {
//           name,
//           credits,
//           grand_total_value,
//           player_value_sum,
//           differenceValue,
//           latest_inc,
//           totalDeposit,
//         } = response.data;
//         setUserName(name);
//         setCredits(credits);
//         setInPlayValue(grand_total_value);
//         setTotalSpent(player_value_sum);
//         setDifferenceValue(differenceValue);
//         setplayerval(latest_inc);
//         setTotalCreditFromApi(totalDeposit || 0);
//         console.log(
//           "🟢 Set user values:",
//           JSON.stringify(
//             {
//               name,
//               credits,
//               grand_total_value,
//               player_value_sum,
//               differenceValue,
//               latest_inc,
//               totalDeposit,
//             },
//             null,
//             2
//           )
//         );
//       } catch (error) {
//         console.error("❌ Error fetching in-play values:", error.message);
//       }
//     }
//   };

//   useEffect(() => {
//     fetchUserValues();
//   }, []);

//   const handleSubscribe = async () => {
//     if (!email) {
//       setMessage("Please enter a valid email.");
//       return;
//     }

//     try {
//       const response = await fetch(
//         "https://api.convertkit.com/v3/forms/7878458/subscribe",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             api_key: "3bkwOyREXJsvpFPZ5iUAAw",
//             email: email,
//           }),
//         }
//       );

//       const data = await response.json();
//       if (data.subscription) {
//         setMessage(
//           "Success! Please check your email to confirm your subscription."
//         );
//         setEmail("");
//       } else {
//         setMessage(data.message || "Something went wrong.");
//       }
//     } catch (error) {
//       setMessage("Subscription failed. Please try again later.");
//       console.error("❌ Subscription error:", error.message);
//     }
//   };

//   const handleEmailClick = () => {
//     const email = "contact@toptennis.io";
//     const subject = "";
//     const body = "";
//     const url = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
//       subject
//     )}&body=${encodeURIComponent(body)}`;
//     window.open(url, "_blank");
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("user_token");
//     localStorage.removeItem("fullName");
//     localStorage.removeItem("userId");
//     localStorage.removeItem("user_isfrozen");
//     localStorage.removeItem("email");
//     console.log("🟢 User logged out successfully");
//     navigate("/");
//   };

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   const [tradingHistory, setTradingHistory] = useState([]);

//   useEffect(() => {
//     const fetchTradingHistory = async () => {
//       const Token = localStorage.getItem("user_token");
//       if (!Token) return;
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       const userId = decodedToken._id;

//       try {
//         const response = await axios.get(
//           `https://toptennis.io/api/users/user/trading-history/${userId}`,
//           { headers: { Authorization: `Bearer ${Token}` } }
//         );
//         let history = [];
//         if (Array.isArray(response.data)) {
//           history = response.data;
//         } else if (Array.isArray(response.data.data)) {
//           history = response.data.data;
//         } else if (Array.isArray(response.data.history)) {
//           history = response.data.history;
//         } else if (Array.isArray(response.data.transactions)) {
//           history = response.data.transactions;
//         }
//         setTradingHistory(history);
//         console.log(
//           "📥 Trading history response:",
//           JSON.stringify(history, null, 2)
//         );

//         const lots = {};
//         if (Array.isArray(history)) {
//           history.forEach((tx) => {
//             if (!lots[tx.player_name]) lots[tx.player_name] = [];
//             if (tx.type === "buy") {
//               lots[tx.player_name].push({
//                 price: tx.value,
//                 qty: tx.quantity,
//                 type: "buy",
//                 timestamp: tx.date,
//               });
//             } else if (tx.type === "sell") {
//               lots[tx.player_name].push({
//                 price: tx.value,
//                 qty: tx.quantity,
//                 type: "sell",
//                 timestamp: tx.date,
//               });
//             }
//           });
//         }
//         setPlayerLots(lots);
//         console.log("🟢 Set player lots:", JSON.stringify(lots, null, 2));
//       } catch (error) {
//         console.error("❌ Error fetching trading history:", error.message);
//       }
//     };

//     fetchTradingHistory();
//   }, []);

//   // Handle market freeze/unfreeze
//   useEffect(() => {
//     if (isMarketFrozen !== prevIsMarketFrozen) {
//       console.log(
//         "🔔 Market freeze state changed:",
//         prevIsMarketFrozen,
//         "->",
//         isMarketFrozen
//       );
//       if (isMarketFrozen === false) {
//         // Market just unfroze, reset lots
//         setPlayerLots({});
//         console.log("🟢 Reset player lots on market unfreeze");
//       }

//       const prevFreezeData = getPrevFreezeData();
//       let incSum = 0;

//       setPlayers((prevPlayers) => {
//         const updatedPlayers = prevPlayers.map((player) => {
//           const prev = prevFreezeData[player._id];
//           let inc = 0;
//           if (prev) {
//             inc =
//               (player.currentValue - prev.lastFreezePrice) *
//               prev.lastFreezeShareQty;
//           }
//           incSum += inc;
//           const updatedPlayer = {
//             ...player,
//             lastFreezePrice: player.currentValue,
//             lastFreezeShareQty: player.share_quantity,
//             lastFreezeSellQty: player.sell_qty,
//           };
//           console.log(
//             `🔄 Updated player ${player.name} on freeze change:`,
//             JSON.stringify(updatedPlayer, null, 2)
//           );
//           return updatedPlayer;
//         });

//         const newFreezeData = {};
//         updatedPlayers.forEach((player) => {
//           newFreezeData[player._id] = {
//             lastFreezePrice: player.currentValue,
//             lastFreezeShareQty: player.share_quantity,
//             lastFreezeSellQty: player.sell_qty,
//           };
//         });
//         setPrevFreezeData(newFreezeData);
//         console.log(
//           "🟢 Set prev freeze data:",
//           JSON.stringify(newFreezeData, null, 2)
//         );

//         setInc(incSum);
//         console.log("🟢 Set inc on freeze change:", incSum);

//         return updatedPlayers;
//       });

//       setPrevIsMarketFrozen(isMarketFrozen);
//     }
//   }, [isMarketFrozen]);

//   const playerSummary = {};
//   if (Array.isArray(tradingHistory) && tradingHistory.length > 0) {
//     const lastBuyQtys = {};
//     const sortedHistory = [...tradingHistory].sort(
//       (a, b) => new Date(b.date) - new Date(a.date)
//     );

//     for (const tx of sortedHistory) {
//       if (
//         tx.type === "buy" &&
//         typeof lastBuyQtys[tx.player_name] === "undefined"
//       ) {
//         lastBuyQtys[tx.player_name] = tx.quantity;
//       }
//     }

//     tradingHistory.forEach((tx) => {
//       if (!playerSummary[tx.player_name]) {
//         playerSummary[tx.player_name] = {
//           name: tx.player_name,
//           totalBought: 0,
//           totalSpent: 0,
//           totalSold: 0,
//           totalReceived: 0,
//           transactions: [],
//           last_buy_qty: lastBuyQtys[tx.player_name] || 0,
//         };
//       }
//       if (tx.type === "buy") {
//         playerSummary[tx.player_name].totalBought += tx.quantity;
//         playerSummary[tx.player_name].totalSpent += tx.value * tx.quantity;
//       } else if (tx.type === "sell") {
//         playerSummary[tx.player_name].totalSold += tx.quantity;
//         playerSummary[tx.player_name].totalReceived += tx.value * tx.quantity;
//       }
//       playerSummary[tx.player_name].transactions.push(tx);
//     });
//   }

//   const totalCurrentPL = players.reduce((sum, player) => {
//     const summary = playerSummary[player.name] || {};
//     const tBought = summary.totalBought || 0;
//     const tSold = summary.totalSold || 0;
//     const tSpent = summary.totalSpent || 0;
//     const tReceived = summary.totalReceived || 0;
//     const avgBuy = tBought > 0 ? tSpent / tBought : 0;
//     const realized = tSold > 0 ? tReceived - avgBuy * tSold : 0;
//     const qty = player.share_quantity || 0;
//     const cValue = player.currentValue || 0;
//     const unrealized = qty > 0 ? (cValue - avgBuy) * qty : 0;
//     const tPL = realized + unrealized;
//     return sum + tPL;
//   }, 0);

//   const getPrevFreezeData = () =>
//     JSON.parse(localStorage.getItem("playerPrevFreezeData") || "{}");
//   const setPrevFreezeData = (data) =>
//     localStorage.setItem("playerPrevFreezeData", JSON.stringify(data));

//   const safeInc = typeof inc === "number" && !isNaN(inc) ? inc : 0;

//   function getLifoLots(tradingHistory, players) {
//     const playerLots = {};
//     players.forEach((player) => {
//       playerLots[player.name] = [];
//     });

//     const sortedHistory = [...tradingHistory].sort(
//       (a, b) => new Date(a.date) - new Date(b.date)
//     );

//     for (const tx of sortedHistory) {
//       if (!playerLots[tx.player_name]) playerLots[tx.player_name] = [];
//       if (tx.type === "buy") {
//         playerLots[tx.player_name].push({
//           price: tx.value,
//           qty: tx.quantity,
//           originalQty: tx.quantity,
//           date: tx.date,
//         });
//       } else if (tx.type === "sell") {
//         let qtyToSell = tx.quantity;
//         while (qtyToSell > 0 && playerLots[tx.player_name].length > 0) {
//           const lastLot =
//             playerLots[tx.player_name][playerLots[tx.player_name].length - 1];
//           if (lastLot.qty > qtyToSell) {
//             lastLot.qty -= qtyToSell;
//             qtyToSell = 0;
//           } else {
//             qtyToSell -= lastLot.qty;
//             playerLots[tx.player_name].pop();
//           }
//         }
//       }
//     }

//     Object.keys(playerLots).forEach((name) => {
//       playerLots[name] = playerLots[name].filter((lot) => lot.qty > 0);
//     });

//     return playerLots;
//   }

//   const lifoLots = useMemo(
//     () => getLifoLots(tradingHistory, players),
//     [tradingHistory, players]
//   );

//   const tableTotalPL = useMemo(() => {
//     let total = 0;
//     players.forEach((player) => {
//       const lots = lifoLots[player.name] || [];
//       if (lots.length === 0) {
//         const purchaseValue = Number(player.value) || 0;
//         const currentValue = Number(player.currentValue) || 0;
//         const shareQty = Number(player.share_quantity) || 0;
//         const plPerShare = currentValue - purchaseValue;
//         const totalPL = plPerShare * shareQty;
//         if (totalPL !== 0) total += totalPL;
//       } else {
//         lots.forEach((lot) => {
//           const purchaseValue = Number(lot.price) || 0;
//           const currentValue = Number(player.currentValue) || 0;
//           const shareQty = Number(lot.qty) || 0;
//           const plPerShare = currentValue - purchaseValue;
//           const totalPL = plPerShare * shareQty;
//           if (totalPL !== 0) total += totalPL;
//         });
//       }
//     });
//     console.log("📊 Calculated tableTotalPL:", total);
//     return total;
//   }, [players, lifoLots]);

//   useEffect(() => {
//     console.log(
//       "🔄 Players state changed, re-rendering table:",
//       JSON.stringify(players, null, 2)
//     );
//   }, [players]);

//   return (
//     <>
//       {isLoading && (
//         <div className="loader-overlay">
//           <div className="loader"></div>
//         </div>
//       )}
//       <Container className="justify-content-center align-items-center n-new cn">
//         <Row className="w-100 justify-content-center rowdiv">
//           <div className="freeze-banner">
//             <p>{freezeMessage} </p>
//           </div>

//           <div className="user-info">
//             <button
//               variant="light"
//               className="d-md-none menu-btn "
//               onClick={handleShow1}
//             >
//               ☰
//             </button>
//             <div className="left-section1 d-flex1">
//               <span className="welcome-text">Welcome, {userName}</span>
//               <div className="top-navigation d-none d-md-flex">
//                 <span className="nav-item" onClick={() => navigate("/home")}>
//                   Home
//                 </span>
//                 <span
//                   className="nav-item active"
//                   onClick={() => navigate("/profile")}
//                 >
//                   Profile
//                 </span>
//                 <span className="nav-item" onClick={() => navigate("/myteam")}>
//                   My Team
//                 </span>
//                 <span className="nav-item" onClick={() => navigate("/faq")}>
//                   FAQs
//                 </span>
//                 <span className="nav-item" onClick={() => navigate("/news")}>
//                   News
//                 </span>
//                 <span className="nav-item" onClick={handleLogout}>
//                   Logout
//                 </span>
//               </div>
//             </div>

//             <Offcanvas show={show1} onHide={handleClose1} placement="start">
//               <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>Menu</Offcanvas.Title>
//               </Offcanvas.Header>
//               <Offcanvas.Body>
//                 <div className="mobile-nav">
//                   <span
//                     className="nav-item "
//                     onClick={() => {
//                       navigate("/home");
//                       handleClose1();
//                     }}
//                   >
//                     Home
//                   </span>
//                   <span
//                     className="nav-item active"
//                     onClick={() => {
//                       navigate("/profile");
//                       handleClose1();
//                     }}
//                   >
//                     Profile
//                   </span>
//                   <span
//                     className="nav-item "
//                     onClick={() => {
//                       navigate("/myteam");
//                       handleClose1();
//                     }}
//                   >
//                     My Team
//                   </span>
//                   <span
//                     className="nav-item"
//                     onClick={() => {
//                       navigate("/faq");
//                       handleClose1();
//                     }}
//                   >
//                     FAQs
//                   </span>
//                   <span
//                     className="nav-item"
//                     onClick={() => {
//                       navigate("/news");
//                       handleClose1();
//                     }}
//                   >
//                     News
//                   </span>
//                   <span
//                     className="nav-item"
//                     onClick={() => {
//                       handleLogout();
//                       handleClose1();
//                     }}
//                   >
//                     Logout
//                   </span>
//                 </div>
//               </Offcanvas.Body>
//             </Offcanvas>

//             <div className="right-section1">
//               <div className="credit-box-container">
//                 <button
//                   className="topup-button"
//                   onClick={() => {
//                     navigate("/topup");
//                   }}
//                 >
//                   Top-up
//                 </button>
//                 <div className="credit-box">
//                   <p className="p">
//                     Credit available: <span>{credits?.toFixed(2)}</span>
//                   </p>
//                   <p className="p">
//                     In-play: <span>{inPlayValue.toFixed(2)}</span>
//                   </p>
//                   <p className="p">
//                     Current Team P/L:&nbsp;
//                     <span
//                       style={{
//                         color:
//                           Number(differenceValue) > 0
//                             ? "green"
//                             : Number(differenceValue) < 0
//                             ? "red"
//                             : "black",
//                       }}
//                     >
//                       {differenceValue
//                         ? Number(differenceValue) > 0
//                           ? `+${Number(differenceValue).toFixed(2)}`
//                           : Number(differenceValue).toFixed(2)
//                         : "0.00"}
//                     </span>
//                   </p>
//                   <button
//                     className="topup-button-mobile"
//                     onClick={() => {
//                       navigate("/topup");
//                     }}
//                   >
//                     Top-up
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <Col xs={12} sm={10} md={8}>
//             <div
//               style={{
//                 padding: "10px",
//                 background: "",
//                 borderRadius: "8px",
//                 boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
//                 height: "auto",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   marginBottom: "10px",
//                 }}
//               >
//                 <h3 style={{ margin: 0 }}>Profile Information</h3>
//                 <button
//                   onClick={handleEditClick}
//                   style={{
//                     color: "black",
//                     border: "none",
//                     borderRadius: "4px",
//                     padding: "6px 16px",
//                     fontWeight: "bold",
//                     cursor: "pointer",
//                     fontSize: "20px",
//                   }}
//                 >
//                   Edit Profile
//                 </button>
//               </div>
//               <Table
//                 striped
//                 bordered
//                 hover
//                 responsive
//                 style={{ width: "100%" }}
//               >
//                 <thead>
//                   <tr>
//                     <th style={{ width: "12%" }}>Full Name</th>
//                     <th style={{ width: "12%" }}>Email</th>
//                     <th style={{ width: "12%" }}>Phone No.</th>
//                     <th style={{ width: "12%" }}>DOB</th>
//                     <th style={{ width: "20%" }}>Credits</th>
//                     <th style={{ width: "15%" }}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="table-body">
//                   <tr>
//                     <td className="td1">{profileData.name}</td>
//                     <td className="td1">{profileData.email}</td>
//                     <td className="td1">{profileData.phone}</td>
//                     <td className="td1">
//                       {new Date(profileData.dob).toLocaleDateString("en-GB")}
//                     </td>
//                     <td className="td1">
//                       {typeof profileData.credits === "number"
//                         ? profileData.credits.toFixed(2)
//                         : "0.00"}
//                     </td>
//                     <td
//                       className="td1"
//                       style={{ whiteSpace: "nowrap", textAlign: "center" }}
//                     >
//                       <span
//                         style={{
//                           color: "#222",
//                           fontWeight: "bold",
//                           cursor: "pointer",
//                           textDecoration: "underline",
//                           marginRight: "10px",
//                         }}
//                         onClick={() => navigate("/topup")}
//                       >
//                         TOP-UP
//                       </span>
//                       <span style={{ fontWeight: "bold", margin: "0 5px" }}>
//                         |
//                       </span>
//                       <span
//                         style={{
//                           color: "#222",
//                           fontWeight: "bold",
//                           cursor: "pointer",
//                           textDecoration: "underline",
//                         }}
//                         onClick={() => navigate("/withdraw")}
//                       >
//                         WITHDRAW
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </Table>
//               <Modal show={showModal} onHide={handleClose} size="lg">
//                 <Modal.Header
//                   style={{
//                     backgroundColor: "#333",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <Modal.Title
//                     style={{ color: "white", margin: 0, fontSize: "18px" }}
//                   >
//                     Edit Profile
//                   </Modal.Title>
//                   <div style={{ cursor: "pointer" }}>
//                     <i
//                       className="fa fa-times"
//                       onClick={handleClose}
//                       style={{ color: "#fff", fontSize: "20px" }}
//                     ></i>
//                   </div>
//                 </Modal.Header>
//                 <Modal.Body style={{ backgroundColor: "white" }}>
//                   <Form onSubmit={handleSubmit}>
//                     <Form.Group controlId="formName">
//                       <Form.Label>Name</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="name"
//                         value={formData.name}
//                         onChange={handleInputChange}
//                         className="form-control"
//                       />
//                     </Form.Group>

//                     <Form.Group controlId="formPassword">
//                       <Form.Label>Password</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="password"
//                         value={isEditing ? password : "******"}
//                         onChange={handleInputChange}
//                         isInvalid={!!passwordError}
//                       />
//                       <Form.Control.Feedback
//                         type="invalid"
//                         style={{ paddingLeft: "3%" }}
//                       >
//                         {passwordError}
//                       </Form.Control.Feedback>
//                     </Form.Group>

//                     <Form.Group controlId="formEmail">
//                       <Form.Label>Email</Form.Label>
//                       <Form.Control
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleInputChange}
//                       />
//                     </Form.Group>
//                     <Form.Group controlId="formPhone">
//                       <Form.Label>Phone</Form.Label>
//                       <Form.Control
//                         type="tel"
//                         name="phone"
//                         maxlength="14"
//                         oninput="this.value = this.value.replace(/[^0-9]/g, '')"
//                         inputmode="numeric"
//                         value={formData.phone}
//                         onChange={handleInputChange}
//                         isInvalid={!!phoneError}
//                       />
//                       <Form.Control.Feedback
//                         type="invalid"
//                         style={{ paddingLeft: "3%" }}
//                       >
//                         {phoneError}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                     <Form.Group controlId="formDOB">
//                       <Form.Label>Date of Birth</Form.Label>
//                       <div
//                         className={`datepicker-wrapper ${
//                           DobError ? "is-invalid" : ""
//                         }`}
//                       >
//                         <DatePicker
//                           selected={formData.dob}
//                           onChange={(date) =>
//                             setFormData({ ...formData, dob: date })
//                           }
//                           dateFormat="dd-MM-yyyy"
//                           maxDate={new Date()}
//                           showYearDropdown
//                           scrollableYearDropdown
//                           yearDropdownItemNumber={100}
//                           placeholderText="Select DOB"
//                           className={`form-control ${
//                             DobError ? "is-invalid" : ""
//                           }`}
//                         />
//                       </div>
//                       {DobError && (
//                         <div
//                           className="invalid-feedback"
//                           style={{ paddingLeft: "3%" }}
//                         >
//                           {DobError}
//                         </div>
//                       )}
//                     </Form.Group>

//                     <div className="button-container">
//                       <Button variant="primary" type="submit" className="btn5">
//                         Save
//                       </Button>
//                     </div>
//                   </Form>
//                 </Modal.Body>
//               </Modal>

//               {profileData.team && (
//                 <div className="mt-4 mb-5" style={{ height: "100%" }}>
//                   <h5 className="mt-3">Players</h5>
//                   <div>
//                     <Table
//                       striped
//                       bordered
//                       hover
//                       responsive
//                       style={{ width: "100%" }}
//                     >
//                       <thead>
//                         <tr>
//                           <th style={{ width: "20%" }}>Name</th>
//                           <th style={{ width: "15%" }}>Purchase Value</th>
//                           <th style={{ width: "15%" }}>Current Value</th>
//                           <th style={{ width: "15%" }}>Share Quantity</th>
//                           <th style={{ width: "15%" }}>Total Value</th>
//                           <th style={{ width: "10%" }}>P/L Per Share</th>
//                           <th style={{ width: "10%" }}>CURRENT TOTAL P/L</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {playersLoading ? (
//                           <tr>
//                             <td colSpan={7} style={{ textAlign: "center" }}>
//                               <div
//                                 className="spinner-border mt-2"
//                                 role="status"
//                               >
//                                 <span className="visually-hidden">
//                                   Loading...
//                                 </span>
//                               </div>
//                             </td>
//                           </tr>
//                         ) : !Array.isArray(players) || players.length === 0 ? (
//                           <tr>
//                             <td colSpan={7} style={{ textAlign: "center" }}>
//                               <button
//                                 className="btn btn-primary"
//                                 onClick={() => navigate("/myteam")}
//                                 style={{
//                                   margin: "16px 0",
//                                   width: "200px",
//                                   display: "inline-block",
//                                 }}
//                               >
//                                 BUILD YOUR TEAM
//                               </button>
//                             </td>
//                           </tr>
//                         ) : (
//                           players.flatMap((player) => {
//                             const lots = lifoLots[player.name] || [];
//                             if (lots.length === 0) {
//                               const purchaseValue = Number(player.value) || 0;
//                               const currentValue =
//                                 Number(player.currentValue) || 0;
//                               const shareQty =
//                                 Number(player.share_quantity) || 0;
//                               const totalValue = currentValue * shareQty;
//                               const plPerShare = currentValue - purchaseValue;
//                               const totalPL = plPerShare * shareQty;
//                               console.log(
//                                 `📋 Rendering player ${player.name}:`,
//                                 JSON.stringify(
//                                   {
//                                     purchaseValue,
//                                     currentValue,
//                                     shareQty,
//                                     totalValue,
//                                     plPerShare,
//                                     totalPL,
//                                   },
//                                   null,
//                                   2
//                                 )
//                               );
//                               return [
//                                 <tr key={player._id}>
//                                   <td style={{ width: "20%" }} className="td1">
//                                     {player.name || "N/A"}
//                                   </td>
//                                   <td style={{ width: "15%" }} className="td1">
//                                     {purchaseValue.toFixed(2)}
//                                   </td>
//                                   <td style={{ width: "15%" }} className="td1">
//                                     {currentValue.toFixed(2)}
//                                   </td>
//                                   <td style={{ width: "15%" }} className="td1">
//                                     {shareQty}
//                                   </td>
//                                   <td style={{ width: "15%" }} className="td1">
//                                     {totalValue.toFixed(2)}
//                                   </td>
//                                   <td
//                                     style={{
//                                       width: "10%",
//                                       color:
//                                         plPerShare > 0
//                                           ? "green"
//                                           : plPerShare < 0
//                                           ? "red"
//                                           : "black",
//                                     }}
//                                     className="td1"
//                                   >
//                                     {plPerShare > 0 ? "+" : ""}
//                                     {plPerShare.toFixed(2)}
//                                   </td>
//                                   <td
//                                     style={{
//                                       width: "10%",
//                                       color:
//                                         totalPL > 0
//                                           ? "green"
//                                           : totalPL < 0
//                                           ? "red"
//                                           : "black",
//                                     }}
//                                     className="td1"
//                                   >
//                                     {totalPL > 0 ? "+" : ""}
//                                     {totalPL.toFixed(2)}
//                                   </td>
//                                 </tr>,
//                               ];
//                             }
//                             return lots.map((lot, idx) => {
//                               const purchaseValue = Number(lot.price) || 0;
//                               const currentValue =
//                                 Number(player.currentValue) || 0;
//                               const shareQty = Number(lot.qty) || 0;
//                               const totalValue = currentValue * shareQty;
//                               const plPerShare = currentValue - purchaseValue;
//                               const totalPL = plPerShare * shareQty;
//                               console.log(
//                                 `📋 Rendering lot for ${player.name} (index ${idx}):`,
//                                 JSON.stringify(
//                                   {
//                                     purchaseValue,
//                                     currentValue,
//                                     shareQty,
//                                     totalValue,
//                                     plPerShare,
//                                     totalPL,
//                                   },
//                                   null,
//                                   2
//                                 )
//                               );
//                               return (
//                                 <tr key={`${player._id}-lot-${idx}`}>
//                                   <td style={{ width: "20%" }} className="td1">
//                                     {player.name || "N/A"}
//                                   </td>
//                                   <td style={{ width: "15%" }} className="td1">
//                                     {purchaseValue.toFixed(2)}
//                                   </td>
//                                   <td style={{ width: "15%" }} className="td1">
//                                     {currentValue.toFixed(2)}
//                                   </td>
//                                   <td style={{ width: "15%" }} className="td1">
//                                     {shareQty}
//                                   </td>
//                                   <td style={{ width: "15%" }} className="td1">
//                                     {totalValue.toFixed(2)}
//                                   </td>
//                                   <td
//                                     style={{
//                                       width: "10%",
//                                       color:
//                                         plPerShare > 0
//                                           ? "green"
//                                           : plPerShare < 0
//                                           ? "red"
//                                           : "black",
//                                     }}
//                                     className="td1"
//                                   >
//                                     {plPerShare > 0 ? "+" : ""}
//                                     {plPerShare.toFixed(2)}
//                                   </td>
//                                   <td
//                                     style={{
//                                       width: "10%",
//                                       color:
//                                         totalPL > 0
//                                           ? "green"
//                                           : totalPL < 0
//                                           ? "red"
//                                           : "black",
//                                     }}
//                                     className="td1"
//                                   >
//                                     {totalPL > 0 ? "+" : ""}
//                                     {totalPL.toFixed(2)}
//                                   </td>
//                                 </tr>
//                               );
//                             });
//                           })
//                         )}
//                       </tbody>
//                       <tfoot>
//                         <tr>
//                           <td
//                             colSpan="4"
//                             style={{ textAlign: "right", fontWeight: "bold" }}
//                           ></td>
//                           <td className="td1" style={{ fontWeight: "bold" }}>
//                             {players
//                               .reduce(
//                                 (sum, player) =>
//                                   sum +
//                                   (Number(player.currentValue) || 0) *
//                                     (Number(player.share_quantity) || 0),
//                                 0
//                               )
//                               .toFixed(2)}
//                           </td>
//                           <td></td>
//                           <td
//                             className="td1"
//                             style={{
//                               fontWeight: "bold",
//                               color:
//                                 tableTotalPL > 0
//                                   ? "green"
//                                   : tableTotalPL < 0
//                                   ? "red"
//                                   : "black",
//                             }}
//                           >
//                             {tableTotalPL > 0
//                               ? `+${tableTotalPL.toFixed(2)}`
//                               : tableTotalPL.toFixed(2)}
//                           </td>
//                         </tr>
//                       </tfoot>
//                     </Table>
//                   </div>
//                 </div>
//               )}

//               {profileData.team && (
//                 <div className="mt-4 mb-5" style={{ height: "100%" }}>
//                   <h5 className="mt-3">History</h5>
//                   <div>
//                     <Table
//                       striped
//                       bordered
//                       hover
//                       responsive
//                       style={{ width: "100%" }}
//                     >
//                       <thead>
//                         <tr>
//                           <th style={{ width: "14%" }}>DATE</th>
//                           <th style={{ width: "14%" }}>TYPE</th>
//                           <th style={{ width: "14%" }}>NAME</th>
//                           <th style={{ width: "12%" }}>VALUE</th>
//                           <th style={{ width: "12%" }}>BUY QTY</th>
//                           <th style={{ width: "12%" }}>SELL QTY</th>
//                           <th style={{ width: "12%" }}>TOTAL VALUE</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {(Array.isArray(tradingHistory) ? tradingHistory : [])
//                           .filter((tx) => Number(tx.quantity) > 0)
//                           .sort((a, b) => new Date(b.date) - new Date(a.date))
//                           .slice(
//                             (currentPage - 1) * itemsPerPage,
//                             currentPage * itemsPerPage
//                           )
//                           .map((tx, idx) => {
//                             const date = tx.date
//                               ? new Date(tx.date).toLocaleDateString("en-GB", {
//                                   day: "2-digit",
//                                   month: "2-digit",
//                                   year: "numeric",
//                                 })
//                               : "-";

//                             const isPlayerTransaction =
//                               tx.transaction_type === "player_transaction";
//                             const displayType = tx.type
//                               .replace(/_/g, " ")
//                               .toUpperCase();
//                             const displayName = tx.player_name || "-";
//                             const displayValue = tx.value?.toFixed(2) || "-";
//                             const displayBuyQty =
//                               isPlayerTransaction && tx.type === "buy"
//                                 ? tx.quantity
//                                 : "-";
//                             const displaySellQty =
//                               isPlayerTransaction && tx.type === "sell"
//                                 ? tx.quantity
//                                 : "-";
//                             const displayTotalValue = (
//                               tx.total_value || 0
//                             ).toFixed(2);

//                             return (
//                               <tr key={idx}>
//                                 <td>{date}</td>
//                                 <td>{displayType}</td>
//                                 <td>{displayName}</td>
//                                 <td>{displayValue}</td>
//                                 <td>{displayBuyQty}</td>
//                                 <td>{displaySellQty}</td>
//                                 <td>{displayTotalValue}</td>
//                               </tr>
//                             );
//                           })}
//                         {tradingHistory.length === 0 && (
//                           <tr>
//                             <td colSpan={7} style={{ textAlign: "center" }}>
//                               <p>No History Found</p>
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </Table>

//                     <div className="d-flex justify-content-center mt-3">
//                       <nav>
//                         <ul className="pagination">
//                           <li
//                             className={`page-item ${
//                               currentPage === 1 ? "disabled" : ""
//                             }`}
//                           >
//                             <button
//                               className="page-link"
//                               onClick={() =>
//                                 setCurrentPage((prev) => Math.max(prev - 1, 1))
//                               }
//                               disabled={currentPage === 1}
//                             >
//                               Previous
//                             </button>
//                           </li>
//                           {[
//                             ...Array(
//                               Math.ceil(
//                                 (Array.isArray(tradingHistory)
//                                   ? tradingHistory.filter(
//                                       (tx) => Number(tx.quantity) > 0
//                                     )
//                                   : []
//                                 ).length / itemsPerPage
//                               )
//                             ),
//                           ].map((_, index) => (
//                             <li
//                               key={index + 1}
//                               className={`page-item ${
//                                 currentPage === index + 1 ? "active" : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() => setCurrentPage(index + 1)}
//                               >
//                                 {index + 1}
//                               </button>
//                             </li>
//                           ))}
//                           <li
//                             className={`page-item ${
//                               currentPage ===
//                               Math.ceil(
//                                 (Array.isArray(tradingHistory)
//                                   ? tradingHistory.filter(
//                                       (tx) => Number(tx.quantity) > 0
//                                     )
//                                   : []
//                                 ).length / itemsPerPage
//                               )
//                                 ? "disabled"
//                                 : ""
//                             }`}
//                           >
//                             <button
//                               className="page-link"
//                               onClick={() =>
//                                 setCurrentPage((prev) =>
//                                   Math.min(
//                                     prev + 1,
//                                     Math.ceil(
//                                       (Array.isArray(tradingHistory)
//                                         ? tradingHistory.filter(
//                                             (tx) => Number(tx.quantity) > 0
//                                           )
//                                         : []
//                                       ).length / itemsPerPage
//                                     )
//                                   )
//                                 )
//                               }
//                               disabled={
//                                 currentPage ===
//                                 Math.ceil(
//                                   (Array.isArray(tradingHistory)
//                                     ? tradingHistory.filter(
//                                         (tx) => Number(tx.quantity) > 0
//                                       )
//                                     : []
//                                   ).length / itemsPerPage
//                                 )
//                               }
//                             >
//                               Next
//                             </button>
//                           </li>
//                         </ul>
//                       </nav>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </Col>
//         </Row>
//         <div className="card-footer3">
//           <div className="footer">
//             <div className="footer-firstline">
//               <div className="footer-sub">
//                 <h4>Keep in touch</h4>
//                 <h5>Join our newsletter. We promise not to spam!</h5>
//                 <input
//                   type="email"
//                   placeholder="Email Address"
//                   className="footer-input"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//                 <button className="subscribe-btn" onClick={handleSubscribe}>
//                   Subscribe
//                 </button>
//                 {message && (
//                   <p style={{ marginTop: "10px", marginLeft: "5px" }}>
//                     {message}
//                   </p>
//                 )}
//               </div>

//               <div className="footer-sub1">
//                 <h4>Quick links</h4>
//                 <a href="/home" className="footer-link">
//                   Home
//                 </a>
//                 <a href="/profile" className="footer-link">
//                   Profile
//                 </a>
//                 <a href="/myteam" className="footer-link">
//                   My Team
//                 </a>
//                 <a href="/news" className="footer-link">
//                   News
//                 </a>
//                 <a href="/faq" className="footer-link">
//                   FAQs
//                 </a>
//               </div>

//               <div className="footer-sub1 secondicon">
//                 <h4>Socials</h4>
//                 <div className="social-icons">
//                   <a
//                     href="https://www.facebook.com/toptennisio/"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="social-circle"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <i className="fab fa-facebook-f"></i>
//                   </a>
//                   <a
//                     href="https://www.instagram.com/toptennisuk"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="social-circle"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <i className="fab fa-instagram"></i>
//                   </a>
//                 </div>
//                 <div className="fl1">
//                   <a
//                     href="/terms"
//                     className="footer-link"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     T&Cs
//                   </a>
//                   <a
//                     href="/privacy"
//                     className="footer-link"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     Privacy Policy
//                   </a>
//                   <span className="footer-link">
//                     Email: contact@toptennis.io
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Container>
//     </>
//   );
// }

// export default ProfilePage;


// backup before socket.io
// import React, { useState, useEffect, useMemo } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import axios from "axios";
// import Swal from "sweetalert2";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Table,
//   Button,
//   Modal,
//   Offcanvas,
// } from "react-bootstrap";
// import "../Profile/profilepage.css";
// import { useNavigate } from "react-router-dom";

// function ProfilePage() {
//   const [profileData, setProfileData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     phone: "",
//     dob: "",
//     credits: "",
//     profile_image: "",
//     team: null, // Team data to store
//     profile_image: "", // Profile image field
//   });
//   const [totalDeposit, setTotalDeposit] = useState(0);
//   const [isMarketFrozen, setIsMarketFrozen] = useState(false);
//   const [freezeMessage, setFreezeMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [password, setPassword] = useState(""); // Stores new password input
//   const [phoneError, setPhoneError] = useState("");
//   const [playerval, setplayerval] = useState(0);
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [totalCreditFromApi, setTotalCreditFromApi] = useState(0);
//   const [playerLots, setPlayerLots] = useState({}); // { playerId: [ { price, qty, type, timestamp } ] }
//   const [playersLoading, setPlayersLoading] = useState(true);

//   const fetchMarketStatus = async () => {
//     setIsLoading(true); // Start loader
//     try {
//       const Token = localStorage.getItem("user_token");
//       const response = await axios.get(
//         "https://toptennis.io/api/users/market-status",
//         {
//           headers: { Authorization: `Bearer ${Token}` },
//         }
//       );

//       // Extract values from the API response
//       const { isFrozen, bannerText } = response.data;

//       // Update state with both values
//       setIsMarketFrozen(isFrozen);
//       setFreezeMessage(bannerText || ""); // Ensure it's not undefined
//       setIsLoading(false);
//     } catch (error) {
//       console.error("Error fetching market status:", error);
//     } finally {
//       setIsLoading(false); // Ensure loader stops after API response
//     }
//   };

//   // const fetchMarketStatus = async () => {
//   //   try {
//   //     const Token = localStorage.getItem("user_token");
//   //     const response = await axios.get(
//   //       "https://toptennis.io/api/users/market-status",
//   //       {
//   //         headers: { Authorization: `Bearer ${Token}` },
//   //       }
//   //     );

//   //     // Extract values from the API response
//   //     const { isFrozen, bannerText } = response.data;

//   //     // Update state with both values
//   //     setIsMarketFrozen(isFrozen);
//   //     setFreezeMessage(bannerText || ""); // Ensure it's not undefined

//   //   } catch (error) {
//   //     console.error("Error fetching market status:", error);
//   //   }
//   // };

//   // ✅ Only call API once when component mounts
//   useEffect(() => {
//     fetchMarketStatus();
//   }, []);

//   const navigate = useNavigate();

//   const showAutoError = (message) => {
//     Swal.fire({
//       position: "top-end",
//       icon: "error",
//       title: message,
//       showConfirmButton: false,
//       timer: 3000,
//     });
//   };
//   const [players, setPlayers] = useState([]);
//   const [inc, setInc] = useState();
//   useEffect(() => {
//     const fetchPlayersAndMergeData = async () => {
//       const Token = localStorage.getItem("user_token");

//       try {
//         // Decode user ID from token
//         const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//         const userId = decodedToken._id;

//         // Fetch data from API
//         const response = await axios.get(
//           `https://toptennis.io/api/users/selected-teamlist/${userId}`,
//           { headers: { Authorization: `Bearer ${Token}` } }
//         );

//         if (response.data && response.data.status) {
//           const { team, valueDifferences } = response.data;

//           // Create a map of valueDifferences by `player_id`
//           const valueDifferenceMap = valueDifferences.reduce(
//             (acc, valueDifference) => {
//               acc[valueDifference.player_id] = valueDifference;
//               return acc;
//             },
//             {}
//           );

//           // Merge team.players with valueDifferences
//           const mergedData = team.players.map((player) => {
//             const differenceData = valueDifferenceMap[player._id] || {};
//             console.log("Player name from API before merging:", player.name);
//             return {
//               ...player,
//               currentValue: differenceData.value || player.value,
//               valueDifference: differenceData.valueDifference || 0,
//               latest_transaction_time:
//                 differenceData.latest_transaction_time || null,
//               buy_qty: differenceData.buy_qty,
//               sell_qty: differenceData.sell_qty,
//               last_buy_price: differenceData.last_buy_price,
//               last_buy_qty: differenceData.last_buy_qty,
//               share_quantity:
//                 differenceData.share_quantity || player.share_quantity || 0,
//               lastFreezePrice: player.lastFreezePrice || player.value,
//               lastFreezeShareQty:
//                 player.lastFreezeShareQty || player.share_quantity || 0,
//             };
//           });

//           // Update state with merged data
//           setPlayers(mergedData);
//           console.log("Merged Data:", mergedData);

//           // Find the player with the most recent transaction
//           const lastChangedPlayer = mergedData.reduce((latest, player) => {
//             if (!latest) return player;
//             const latestTime = new Date(latest.latest_transaction_time || 0);
//             const playerTime = new Date(player.latest_transaction_time || 0);
//             return playerTime > latestTime ? player : latest;
//           }, null);

//           if (lastChangedPlayer) {
//             const calculatedInc =
//               (Number(lastChangedPlayer.valueDifference) || 0) *
//               (Number(lastChangedPlayer.share_quantity) || 0);

//             setplayerval(calculatedInc); // assuming setplayerval is a valid state setter
//             setInc(calculatedInc);
//             console.log("Last Changed Player:", lastChangedPlayer);
//             console.log("Increment Value:", calculatedInc);
//           }

//           // Add this block to update lots after freeze/unfreeze
//           if (isMarketFrozen === false && prevIsMarketFrozen === true) {
//             // Market just unfroze, reset lots
//             setPlayerLots({});
//           }
//         } else {
//           console.error("Unexpected response format", response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setPlayersLoading(false);
//       }
//     };

//     // Initial call
//     fetchPlayersAndMergeData();

//     // Call every 5 seconds
//     const interval = setInterval(fetchPlayersAndMergeData, 5000);

//     // Cleanup interval on unmount
//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     const fetchProfileData = async () => {
//       try {
//         const Token = localStorage.getItem("user_token");
//         const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//         const userId = decodedToken._id;

//         const response = await axios.get(
//           `https://toptennis.io/api/users/user/profile/${userId}`,
//           {
//             headers: { Authorization: `Bearer ${Token}` },
//           }
//         );

//         if (response.data && response.data.userDetails) {
//           const {
//             name,
//             email,
//             password,
//             credits,
//             team,
//             profile_image,
//             phone,
//             dob,
//           } = response.data.userDetails;
//           setProfileData({
//             name: name || "",
//             email: email || "",
//             password: password || "",
//             phone: phone || "",
//             dob: dob || "",
//             credits: credits || "",
//             team: team || null, // Set team data if available
//             profile_image: profile_image || "", // Ensure profile_image is fetched
//           });
//           console.log(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching profile data", error);
//         if (error.response) {
//           if (
//             error.response.status === 500 &&
//             error.response.data.message === "jwt expired"
//           ) {
//             showAutoError(error.response.data.message);
//           } else {
//             showAutoError("An error occurred while fetching profile data.");
//           }
//         }
//       }
//     };

//     fetchProfileData();
//   }, []);

//   const [showModal, setShowModal] = useState(false);
//   const [formData, setFormData] = useState({
//     name: profileData.name || "",
//     password: profileData.password || "",
//     email: profileData.email || "",
//     dob: profileData.dob || "",
//     phone: profileData.phone || "",
//   });
//   const [profileImage, setProfileImage] = useState(null);
//   const [passwordError, setPasswordError] = useState("");
//   const [DobError, setDobError] = useState("");
//   const formatDOBForInput = (dob) => {
//     if (!dob) return ""; // avoid undefined/null
//     const date = new Date(dob);
//     return date.toISOString().split("T")[0]; // -> "2002-11-20"
//   };
//   // Open modal with current profile data
//   const handleEditClick = () => {
//     setFormData({
//       name: profileData.name,
//       password: profileData.password,
//       email: profileData.email,
//       phone: profileData.phone,
//       dob: formatDOBForInput(profileData.dob),
//     });
//     setShowModal(true);
//   };

//   // Close modal
//   const handleClose = () => setShowModal(false);

//   // Handle form input changes for text fields
//   // const handleInputChange = (e) => {
//   //   const { name, value } = e.target;

//   //   if (name === "password") {
//   //     // Validate password length
//   //     setIsEditing(true); // Enable editing mode
//   //     setPassword(e.target.value); // Store new password
//   //     if (value.length > 12) {
//   //       setPasswordError("Maximum 12 characters.");
//   //     } else {
//   //       setPasswordError(""); // Clear error if valid
//   //     }
//   //   }
//   //   setFormData((prevData) => ({
//   //     ...prevData,
//   //     [name]: value,
//   //   }));
//   // };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "password") {
//       setIsEditing(true);
//       setPassword(value);
//       if (value.length > 12) {
//         setPasswordError("Maximum 12 characters.");
//       } else {
//         setPasswordError("");
//       }
//     }

//     if (name === "phone") {
//       const phoneRegex = /^[0-9]*$/; // only numbers
//       if (value === "") {
//         setPhoneError(""); // No error if empty
//       } else if (!phoneRegex.test(value)) {
//         setPhoneError("Only numeric values are allowed.");
//       } else if (value.length > 14) {
//         setPhoneError("Maximum 14 digits allowed.");
//       } else {
//         setPhoneError("");
//       }
//     }

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   // Handle profile image selection
//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setProfileImage(file);
//     }
//   };

//   const isUnder18 = (dob) => {
//     const today = new Date();
//     const birthDate = new Date(dob);
//     const age = today.getFullYear() - birthDate.getFullYear();
//     const monthDiff = today.getMonth() - birthDate.getMonth();
//     const dayDiff = today.getDate() - birthDate.getDate();

//     if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
//       return age - 1 < 18;
//     }
//     return age < 18;
//   };

//   // Handle form submission
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   if (formData.password.length > 12) {
//   //     setPasswordError("Password must be exactly 12 characters long.");
//   //     return; // Prevent form submission
//   //   }
//   //   if (isUnder18(formData.dob)) {
//   //     setDobError("You must be at least 18 years old.");
//   //     return;
//   //   }
//   //   try {
//   //     const Token = localStorage.getItem("user_token");
//   //     const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//   //     const userId = decodedToken._id;

//   //     // Prepare form data
//   //     const data = new FormData();
//   //     data.append("name", formData.name);
//   //     data.append("password", formData.password);
//   //     data.append("email", formData.email);
//   //     data.append("phone", formData.phone);
//   //     data.append("dob", formData.dob);
//   //     if (profileImage) {
//   //       data.append("profile_image", profileImage);
//   //     }

//   //     const response = await axios.patch(
//   //       `https://toptennis.io/api/users/userdetails-updated/${userId}`,
//   //       data,
//   //       {
//   //         headers: {
//   //           Authorization: `Bearer ${Token}`,
//   //           "Content-Type": "multipart/form-data",
//   //         },
//   //       }
//   //     );

//   //     if (response.status === 201 || response.data.status) {
//   //       navigate("/");
//   //     }

//   //     // Update profileData and close modal
//   //     setProfileData(response.data);

//   //     setShowModal(false);
//   //   } catch (error) {
//   //     console.error("Error updating user details:", error);
//   //   }
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (formData.password.length > 12) {
//       setPasswordError("Password must be exactly 12 characters long.");
//       return;
//     }

//     const numericRegex = /^[0-9]{9,14}$/;
//     if (!numericRegex.test(formData.phone)) {
//       setPhoneError(
//         "Phone number must be 9 to 14 digits and contain only numbers."
//       );
//       return;
//     }

//     if (isUnder18(formData.dob)) {
//       setDobError("You must be at least 18 years old.");
//       return;
//     }

//     // 💬 Confirmation box using SweetAlert2
//     const result = await Swal.fire({
//       title: "Confirm Profile Update",
//       text: "You have changed your profile details. You will need to re-login. Continue?",
//       icon: "warning",
//       showDenyButton: true,
//       confirmButtonText: "Yes, update & logout",
//       denyButtonText: "No, keep existing",
//       buttonsStyling: false,
//       customClass: {
//         confirmButton: "btn btn-success me-2 btn-sm", // Green, Small Button
//         denyButton: "btn btn-danger me-2 btn-sm", // Red, Small Button
//         cancelButton: "btn btn-secondary btn-sm", // Grey, Small Button
//         popup: "custom-popup", // Custom class for popup
//         closeButton: "custom-close-btn", // Close cross button
//       },
//       didOpen: () => {
//         // Add custom close button to the SweetAlert2 modal
//         const closeButton = document.querySelector(".swal2-close");
//         closeButton.classList.add("custom-close-btn"); // Add class for style
//       },
//     });

//     if (result.isDenied || result.isDismissed) {
//       return; // ❌ User canceled or denied update
//     }

//     try {
//       const Token = localStorage.getItem("user_token");
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       const userId = decodedToken._id;

//       const data = new FormData();
//       data.append("name", formData.name);
//       data.append("password", formData.password);
//       data.append("email", formData.email);
//       data.append("phone", formData.phone);
//       data.append("dob", formData.dob);
//       if (profileImage) {
//         data.append("profile_image", profileImage);
//       }

//       const response = await axios.patch(
//         `https://toptennis.io/api/users/userdetails-updated/${userId}`,
//         data,
//         {
//           headers: {
//             Authorization: `Bearer ${Token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       if (response.status === 201 || response.data.status) {
//         navigate("/");
//         setProfileData(response.data);
//         setShowModal(false);
//         localStorage.removeItem("user_token");
//       }
//     } catch (error) {
//       console.error("Error updating user details:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Update Failed",
//         text: error.response?.data?.message || "Something went wrong!",
//       });
//     }
//   };

//   const [show1, setShow1] = useState(false);
//   const [differenceValue, setDifferenceValue] = useState(0);
//   const [inPlayValue, setInPlayValue] = useState(0);
//   const [credits, setCredits] = useState(0);
//   const [userName, setUserName] = useState("");
//   const [totalSpent, setTotalSpent] = useState(0);

//   const handleClose1 = () => setShow1(false);
//   const handleShow1 = () => setShow1(true);
//   const fetchUserValues = async () => {
//     const Token = localStorage.getItem("user_token");

//     if (Token) {
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       const userId = decodedToken._id;

//       try {
//         // Fetch user in-play values
//         const response = await axios.get(
//           `https://toptennis.io/api/users/user/in-play-value/${userId}`,
//           {
//             headers: { Authorization: `Bearer ${Token}` },
//           }
//         );

//         const {
//           name,
//           credits,
//           grand_total_value,
//           player_value_sum,
//           differenceValue,
//           latest_inc,
//           totalDeposit,
//         } = response.data;
//         console.log("CPL:::", response.data);
//         setUserName(name);
//         setCredits(credits);
//         setInPlayValue(grand_total_value);
//         setTotalSpent(player_value_sum);
//         setDifferenceValue(differenceValue);
//         setplayerval(latest_inc);
//         setTotalCreditFromApi(totalDeposit || 0);
//       } catch (error) {
//         console.error("Error fetching in-play values:", error);
//       }
//     }
//   };

//   useEffect(() => {
//     fetchUserValues();
//   }, []);

//   const handleSubscribe = async () => {
//     if (!email) {
//       setMessage("Please enter a valid email.");
//       return;
//     }

//     try {
//       const response = await fetch(
//         "https://api.convertkit.com/v3/forms/7878458/subscribe",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             api_key: "3bkwOyREXJsvpFPZ5iUAAw",
//             email: email,
//           }),
//         }
//       );

//       const data = await response.json();
//       if (data.subscription) {
//         setMessage(
//           "Success! Please check your email to confirm your subscription."
//         );
//         setEmail(""); // Clear input
//       } else {
//         setMessage(data.message || "Something went wrong.");
//       }
//     } catch (error) {
//       setMessage("Subscription failed. Please try again later.");
//       console.error(error);
//     }
//   };

//   const handleEmailClick = () => {
//     const email = "contact@toptennis.io";
//     const subject = "";
//     const body = "";
//     const url = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
//       subject
//     )}&body=${encodeURIComponent(body)}`;
//     window.open(url, "_blank");
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("user_token");
//     localStorage.removeItem("fullName");
//     localStorage.removeItem("userId");
//     localStorage.removeItem("user_isfrozen");
//     localStorage.removeItem("email");
//     console.log("User logged out successfully.");
//     navigate("/");
//   };

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   const [tradingHistory, setTradingHistory] = useState([]);

//   useEffect(() => {
//     const fetchTradingHistory = async () => {
//       const Token = localStorage.getItem("user_token");
//       if (!Token) return;
//       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
//       const userId = decodedToken._id;

//       try {
//         const response = await axios.get(
//           `https://toptennis.io/api/users/user/trading-history/${userId}`,
//           { headers: { Authorization: `Bearer ${Token}` } }
//         );
//         console.log("Trading history response:", response.data);

//         let history = [];
//         if (Array.isArray(response.data)) {
//           history = response.data;
//         } else if (Array.isArray(response.data.data)) {
//           history = response.data.data;
//         } else if (Array.isArray(response.data.history)) {
//           history = response.data.history;
//         } else if (Array.isArray(response.data.transactions)) {
//           history = response.data.transactions;
//         }
//         console.log("Trading history:", history);
//         setTradingHistory(history);

//         // Build lots from trading history (after freeze/unfreeze)
//         const lots = {};
//         let lastFreezeTime = null;
//         if (Array.isArray(history)) {
//           // Find last freeze event (simulate by market freeze/unfreeze)
//           // For now, use component mount as last freeze, or you can store freeze timestamp in localStorage if needed
//           // We'll use all trades for now
//           history.forEach((tx) => {
//             if (!lots[tx.player_name]) lots[tx.player_name] = [];
//             if (tx.type === "buy") {
//               lots[tx.player_name].push({
//                 price: tx.value,
//                 qty: tx.quantity,
//                 type: "buy",
//                 timestamp: tx.date,
//               });
//             } else if (tx.type === "sell") {
//               lots[tx.player_name].push({
//                 price: tx.value,
//                 qty: tx.quantity,
//                 type: "sell",
//                 timestamp: tx.date,
//               });
//             }
//           });
//         }
//         setPlayerLots(lots);
//       } catch (error) {
//         console.error("Error fetching trading history:", error);
//       }
//     };

//     fetchTradingHistory();
//   }, []);

//   // Build player summary from tradingHistory
//   const playerSummary = {};
//   if (Array.isArray(tradingHistory) && tradingHistory.length > 0) {
//     const lastBuyQtys = {};
//     const sortedHistory = [...tradingHistory].sort(
//       (a, b) => new Date(b.date) - new Date(a.date)
//     );

//     for (const tx of sortedHistory) {
//       if (tx.type === "buy" && typeof lastBuyQtys[tx.player_name] === 'undefined') {
//         lastBuyQtys[tx.player_name] = tx.quantity;
//       }
//     }

//     tradingHistory.forEach((tx) => {
//       if (!playerSummary[tx.player_name]) {
//         playerSummary[tx.player_name] = {
//           name: tx.player_name,
//           totalBought: 0,
//           totalSpent: 0,
//           totalSold: 0,
//           totalReceived: 0,
//           transactions: [],
//           last_buy_qty: lastBuyQtys[tx.player_name] || 0,
//         };
//       }
//       if (tx.type === "buy") {
//         playerSummary[tx.player_name].totalBought += tx.quantity;
//         playerSummary[tx.player_name].totalSpent += tx.value * tx.quantity;
//       } else if (tx.type === "sell") {
//         playerSummary[tx.player_name].totalSold += tx.quantity;
//         playerSummary[tx.player_name].totalReceived += tx.value * tx.quantity;
//       }
//       playerSummary[tx.player_name].transactions.push(tx);
//     });
//   }

//   // Calculate total P/L and increment for credit box
//   const totalCurrentPL = players.reduce((sum, player) => {
//     const summary = playerSummary[player.name] || {};
//     const tBought = summary.totalBought || 0;
//     const tSold = summary.totalSold || 0;
//     const tSpent = summary.totalSpent || 0;
//     const tReceived = summary.totalReceived || 0;
//     const avgBuy = tBought > 0 ? tSpent / tBought : 0;
//     const realized = tSold > 0 ? tReceived - avgBuy * tSold : 0;
//     const qty = player.share_quantity || 0;
//     const cValue = player.currentValue || 0;
//     const unrealized = qty > 0 ? (cValue - avgBuy) * qty : 0;
//     const tPL = realized + unrealized;
//     return sum + tPL;
//   }, 0);

//   // 2. Add state to track previous freeze status
//   const [prevIsMarketFrozen, setPrevIsMarketFrozen] = useState(isMarketFrozen);

//   // Utility to get and set previous freeze data
//   const getPrevFreezeData = () =>
//     JSON.parse(localStorage.getItem("playerPrevFreezeData") || "{}");
//   const setPrevFreezeData = (data) =>
//     localStorage.setItem("playerPrevFreezeData", JSON.stringify(data));

//   // 3. useEffect to update lastFreezePrice on freeze/unfreeze and calculate Inc
//   useEffect(() => {
//     if (prevIsMarketFrozen !== isMarketFrozen) {
//       // Get previous freeze data
//       const prevFreezeData = getPrevFreezeData();
//       let incSum = 0;

//       setPlayers((prevPlayers) => {
//         const updatedPlayers = prevPlayers.map((player) => {
//           const prev = prevFreezeData[player._id];
//           let inc = 0;
//           if (prev) {
//             // Calculate Inc for this player
//             inc =
//               (player.currentValue - prev.lastFreezePrice) *
//               prev.lastFreezeShareQty;
//           }
//           incSum += inc;
//           return {
//             ...player,
//             lastFreezePrice: player.currentValue,
//             lastFreezeShareQty: player.share_quantity,
//             lastFreezeSellQty: player.sell_qty, // Track sell_qty at freeze
//           };
//         });

//         // Store new freeze data for next time
//         const newFreezeData = {};
//         updatedPlayers.forEach((player) => {
//           newFreezeData[player._id] = {
//             lastFreezePrice: player.currentValue,
//             lastFreezeShareQty: player.share_quantity,
//             lastFreezeSellQty: player.sell_qty, // Store sell_qty at freeze
//           };
//         });
//         setPrevFreezeData(newFreezeData);

//         // Set Inc value in state
//         setInc(incSum);

//         return updatedPlayers;
//       });

//       setPrevIsMarketFrozen(isMarketFrozen);
//     }
//   }, [isMarketFrozen]);

//   const safeInc = typeof inc === "number" && !isNaN(inc) ? inc : 0;

//   // --- LIFO Remaining Lots Calculation ---
//   function getLifoLots(tradingHistory, players) {
//     // Map: player name -> array of remaining lots (LIFO)
//     const playerLots = {};

//     // Build a stack for each player
//     players.forEach((player) => {
//       playerLots[player.name] = [];
//     });

//     // Sort transactions by date ascending (oldest first)
//     const sortedHistory = [...tradingHistory].sort((a, b) => new Date(a.date) - new Date(b.date));

//     for (const tx of sortedHistory) {
//       if (!playerLots[tx.player_name]) playerLots[tx.player_name] = [];
//       if (tx.type === "buy") {
//         // Push a new lot onto the stack
//         playerLots[tx.player_name].push({
//           price: tx.value,
//           qty: tx.quantity,
//           originalQty: tx.quantity, // for reference
//           date: tx.date,
//         });
//       } else if (tx.type === "sell") {
//         // LIFO: Remove from the end (most recent buys first)
//         let qtyToSell = tx.quantity;
//         while (qtyToSell > 0 && playerLots[tx.player_name].length > 0) {
//           const lastLot = playerLots[tx.player_name][playerLots[tx.player_name].length - 1];
//           if (lastLot.qty > qtyToSell) {
//             lastLot.qty -= qtyToSell;
//             qtyToSell = 0;
//           } else {
//             qtyToSell -= lastLot.qty;
//             playerLots[tx.player_name].pop();
//           }
//         }
//         // If qtyToSell > 0 here, it means more shares were sold than owned; ignore for now
//       }
//     }

//     // Only keep lots with qty > 0
//     Object.keys(playerLots).forEach((name) => {
//       playerLots[name] = playerLots[name].filter((lot) => lot.qty > 0);
//     });

//     return playerLots;
//   }

//   // Memoize LIFO lots calculation
//   const lifoLots = useMemo(() => getLifoLots(tradingHistory, players), [tradingHistory, players]);

//   // Memoize tableTotalPL calculation
//   const tableTotalPL = useMemo(() => {
//     let total = 0;
//     players.forEach(player => {
//       const lots = lifoLots[player.name] || [];
//       if (lots.length === 0) {
//         const purchaseValue = Number(player.value) || 0;
//         const currentValue = Number(player.currentValue) || 0;
//         const shareQty = Number(player.share_quantity) || 0;
//         const plPerShare = currentValue - purchaseValue;
//         const totalPL = plPerShare * shareQty;
//         if (totalPL !== 0) total += totalPL;
//       } else {
//         lots.forEach(lot => {
//           const purchaseValue = Number(lot.price) || 0;
//           const currentValue = Number(player.currentValue) || 0;
//           const shareQty = Number(lot.qty) || 0;
//           const plPerShare = currentValue - purchaseValue;
//           const totalPL = plPerShare * shareQty;
//           if (totalPL !== 0) total += totalPL;
//         });
//       }
//     });
//     return total;
//   }, [players, lifoLots]);

//   return (
//     <>
//       {isLoading && (
//         <div className="loader-overlay">
//           <div className="loader"></div>
//         </div>
//       )}
//       <Container className="justify-content-center align-items-center n-new cn">
//         <Row className="w-100 justify-content-center rowdiv">
//           <div className="freeze-banner">
//             <p>{freezeMessage} </p>
//           </div>

//           <div className="user-info">
//             <button
//               variant="light"
//               className="d-md-none menu-btn "
//               onClick={handleShow1}
//             >
//               ☰ {/* Hamburger Icon */}
//             </button>
//             <div className="left-section1 d-flex1">
//               <span className="welcome-text">Welcome, {userName}</span>
//               <div className="top-navigation d-none d-md-flex">
//                 <span className="nav-item" onClick={() => navigate("/home")}>
//                   Home
//                 </span>
//                 <span
//                   className="nav-item active"
//                   onClick={() => navigate("/profile")}
//                 >
//                   Profile
//                 </span>
//                 <span className="nav-item" onClick={() => navigate("/myteam")}>
//                   My Team
//                 </span>
//                 <span className="nav-item" onClick={() => navigate("/faq")}>
//                   FAQs
//                 </span>
//                 <span className="nav-item" onClick={() => navigate("/news")}>
//                   News
//                 </span>
//                 <span className="nav-item" onClick={handleLogout}>
//                   Logout
//                 </span>
//               </div>
//             </div>

//             <Offcanvas show={show1} onHide={handleClose1} placement="start">
//               <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>Menu</Offcanvas.Title>
//               </Offcanvas.Header>
//               <Offcanvas.Body>
//                 <div className="mobile-nav">
//                   <span
//                     className="nav-item "
//                     onClick={() => {
//                       navigate("/home");
//                       handleClose1();
//                     }}
//                   >
//                     Home
//                   </span>
//                   <span
//                     className="nav-item active"
//                     onClick={() => {
//                       navigate("/profile");
//                       handleClose1();
//                     }}
//                   >
//                     Profile
//                   </span>
//                   <span
//                     className="nav-item "
//                     onClick={() => {
//                       navigate("/myteam");
//                       handleClose1();
//                     }}
//                   >
//                     My Team
//                   </span>
//                   <span
//                     className="nav-item"
//                     onClick={() => {
//                       navigate("/faq");
//                       handleClose1();
//                     }}
//                   >
//                     FAQs
//                   </span>
//                   <span className="nav-item" onClick={() => navigate("/news")}>
//                     News
//                   </span>
//                   <span
//                     className="nav-item"
//                     onClick={() => {
//                       handleLogout();
//                       handleClose1();
//                     }}
//                   >
//                     Logout
//                   </span>
//                 </div>
//               </Offcanvas.Body>
//             </Offcanvas>

//             <div className="right-section1">
//               <div className="credit-box-container">
//                 <button
//                   className="topup-button"
//                   onClick={() => {
//                     navigate("/topup");
//                   }}
//                 >
//                   Top-up
//                 </button>
//                 <div className="credit-box">
//                   <p className="p">
//                     Credit available: <span>{credits?.toFixed(2)}</span>
//                   </p>
//                   <p className="p">
//                     In-play: <span>{inPlayValue.toFixed(2)}</span>
//                   </p>
//                   <p className="p">
//                       Current Team P/L:&nbsp;
//                       <span
//                         style={{
//                           color:
//                             Number(differenceValue) > 0
//                               ? "green"
//                               : Number(differenceValue) < 0
//                               ? "red"
//                               : "black",
//                         }}
//                       >
//                         {differenceValue
//                           ? Number(differenceValue) > 0
//                             ? `+${Number(differenceValue).toFixed(2)}`
//                             : Number(differenceValue).toFixed(2)
//                           : "0.00"}
//                       </span>
//                     </p>
//                   <button
//                     className="topup-button-mobile"
//                     onClick={() => {
//                       navigate("/topup");
//                     }}
//                   >
//                     Top-up
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <Col xs={12} sm={10} md={8}>
//             <div
//               style={{
//                 padding: "10px",
//                 background: "",
//                 borderRadius: "8px",
//                 boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
//                 height: "auto", // Make sure the container takes full height
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   marginBottom: "10px",
//                 }}
//               >
//                 <h3 style={{ margin: 0 }}>Profile Information</h3>
//                 <button
//                   onClick={handleEditClick}
//                   style={{
//                     color: "black",
//                     border: "none",
//                     borderRadius: "4px",
//                     padding: "6px 16px",
//                     fontWeight: "bold",
//                     cursor: "pointer",
//                     fontSize: "20px",
//                   }}
//                 >
//                   Edit Profile
//                 </button>
//               </div>
//               <Table
//                 striped
//                 bordered
//                 hover
//                 responsive
//                 style={{ width: "100%" }}
//               >
//                 <thead>
//                   <tr>
//                     <th style={{ width: "12%" }}>Full Name</th>
//                     {/* <th>Password</th> */}
//                     <th style={{ width: "12%" }}>Email</th>
//                     <th style={{ width: "12%" }}>Phone No.</th>
//                     <th style={{ width: "12%" }}>DOB</th>
//                     <th style={{ width: "20%" }}>Credits</th>
//                     <th style={{ width: "15%" }}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="table-body">
//                   <tr>
//                     <td className="td1">{profileData.name}</td>
//                     <td className="td1">{profileData.email}</td>
//                     <td className="td1">{profileData.phone}</td>
//                     <td className="td1">
//                       {new Date(profileData.dob).toLocaleDateString("en-GB")}
//                     </td>
//                     <td className="td1">
//                       {typeof profileData.credits === "number"
//                         ? profileData.credits.toFixed(2)
//                         : "0.00"}
//                     </td>
//                     <td
//                       className="td1"
//                       style={{ whiteSpace: "nowrap", textAlign: "center" }}
//                     >
//                       <span
//                         style={{
//                           color: "#222",
//                           fontWeight: "bold",
//                           cursor: "pointer",
//                           textDecoration: "underline",
//                           marginRight: "10px",
//                         }}
//                         onClick={() => navigate("/topup")}
//                       >
//                         TOP-UP
//                       </span>
//                       <span style={{ fontWeight: "bold", margin: "0 5px" }}>
//                         |
//                       </span>
//                       <span
//                         style={{
//                           color: "#222",
//                           fontWeight: "bold",
//                           cursor: "pointer",
//                           textDecoration: "underline",
//                         }}
//                         onClick={() => navigate("/withdraw")}
//                       >
//                         WITHDRAW
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </Table>
//               <Modal show={showModal} onHide={handleClose} size="lg">
//                 <Modal.Header
//                   style={{
//                     backgroundColor: "#333",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <Modal.Title
//                     style={{ color: "white", margin: 0, fontSize: "18px" }}
//                   >
//                     Edit Profile
//                   </Modal.Title>
//                   <div style={{ cursor: "pointer" }}>
//                     <i
//                       className="fa fa-times"
//                       onClick={handleClose}
//                       style={{ color: "#fff", fontSize: "20px" }}
//                     ></i>
//                   </div>
//                 </Modal.Header>
//                 <Modal.Body style={{ backgroundColor: "white" }}>
//                   <Form onSubmit={handleSubmit}>
//                     <Form.Group controlId="formName">
//                       <Form.Label>Name</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="name"
//                         value={formData.name}
//                         onChange={handleInputChange}
//                         className="form-control"
//                       />
//                     </Form.Group>

//                     <Form.Group controlId="formPassword">
//                       <Form.Label>Password</Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="password"
//                         // value={formData.password}
//                         value={isEditing ? password : "******"} // Always show "******" until user types
//                         onChange={handleInputChange}
//                         // maxLength={12} // Limits input to 12 characters
//                         isInvalid={!!passwordError} // Highlights field if there's an error
//                       />
//                       <Form.Control.Feedback
//                         type="invalid"
//                         style={{ paddingLeft: "3%" }}
//                       >
//                         {passwordError}
//                       </Form.Control.Feedback>
//                     </Form.Group>

//                     <Form.Group controlId="formEmail">
//                       <Form.Label>Email</Form.Label>
//                       <Form.Control
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleInputChange}
//                       />
//                     </Form.Group>
//                     {/* <Form.Group controlId="formPhone">
//                       <Form.Label>Phone</Form.Label>
//                       <Form.Control
//                         type="tel"
//                         name="phone"
//                         value={formData.phone}
//                         onChange={handleInputChange}
//                       />
//                     </Form.Group> */}
//                     <Form.Group controlId="formPhone">
//                       <Form.Label>Phone</Form.Label>
//                       <Form.Control
//                         type="tel"
//                         name="phone"
//                         maxlength="14"
//                         oninput="this.value = this.value.replace(/[^0-9]/g, '')"
//                         inputmode="numeric"
//                         value={formData.phone}
//                         onChange={handleInputChange}
//                         isInvalid={!!phoneError}
//                       />
//                       <Form.Control.Feedback
//                         type="invalid"
//                         style={{ paddingLeft: "3%" }}
//                       >
//                         {phoneError}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                     <Form.Group controlId="formDOB">
//                       <Form.Label>Date of Birth</Form.Label>
//                       <div
//                         className={`datepicker-wrapper ${
//                           DobError ? "is-invalid" : ""
//                         }`}
//                       >
//                         <DatePicker
//                           selected={formData.dob}
//                           onChange={(date) =>
//                             setFormData({ ...formData, dob: date })
//                           }
//                           dateFormat="dd-MM-yyyy"
//                           maxDate={new Date()}
//                           showYearDropdown
//                           scrollableYearDropdown
//                           yearDropdownItemNumber={100}
//                           placeholderText="Select DOB"
//                           className={`form-control ${
//                             DobError ? "is-invalid" : ""
//                           }`}
//                         />
//                       </div>
//                       {DobError && (
//                         <div
//                           className="invalid-feedback"
//                           style={{ paddingLeft: "3%" }}
//                         >
//                           {DobError}
//                         </div>
//                       )}
//                     </Form.Group>

//                     <div className="button-container">
//                       <Button variant="primary" type="submit" className="btn5">
//                         Save
//                       </Button>
//                     </div>
//                   </Form>
//                 </Modal.Body>
//               </Modal>

//               {/* Display Team and Player Details */}
//               {profileData.team && (
//                 <div className="mt-4 mb-5" style={{ height: "100%" }}>
//                   <h5 className="mt-3">Players</h5>
//                   <div>
//                     <Table
//                       striped
//                       bordered
//                       hover
//                       responsive
//                       style={{ width: "100%" }}
//                     >
//                       <thead>
//                         <tr>
//                           <th style={{ width: "20%" }}>Name</th>
//                           <th style={{ width: "15%" }}>Purchase Value</th>
//                           <th style={{ width: "15%" }}>Current Value</th>
//                           <th style={{ width: "15%" }}>Share Quantity</th>
//                           <th style={{ width: "15%" }}>Total Value</th>
//                           <th style={{ width: "10%" }}>P/L Per Share</th>
//                           <th style={{ width: "10%" }}>CURRENT TOTAL P/L</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {playersLoading ? (
//                           <tr>
//                             <td colSpan={7} style={{ textAlign: 'center' }}>
//                               <div className="spinner-border mt-2" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                               </div>
//                             </td>
//                           </tr>
//                         ) : !Array.isArray(players) || players.length === 0 ? (
//                           <tr>
//                             <td colSpan={7} style={{ textAlign: 'center' }}>
//                               <button
//                                 className="btn btn-primary"
//                                 onClick={() => navigate('/myteam')}
//                                 style={{ margin: '16px 0', width: '200px', display: 'inline-block' }}
//                               >
//                                 BUILD YOUR TEAM
//                               </button>
//                             </td>
//                           </tr>
//                         ) : (
//                           players.flatMap((player) => {
//                             const lots = lifoLots[player.name] || [];
//                             if (lots.length === 0) {
//                               // fallback to single row if no lots
//                               const purchaseValue = Number(player.value) || 0;
//                               const currentValue = Number(player.currentValue) || 0;
//                               const shareQty = Number(player.share_quantity) || 0;
//                               const totalValue = currentValue * shareQty;
//                               const plPerShare = currentValue - purchaseValue;
//                               const totalPL = plPerShare * shareQty;
//                               return [
//                                 <tr key={player._id}>
//                                   <td style={{ width: "20%" }} className="td1">{player.name || "N/A"}</td>
//                                   <td style={{ width: "15%" }} className="td1">{purchaseValue.toFixed(2)}</td>
//                                   <td style={{ width: "15%" }} className="td1">{currentValue.toFixed(2)}</td>
//                                   <td style={{ width: "15%" }} className="td1">{shareQty}</td>
//                                   <td style={{ width: "15%" }} className="td1">{totalValue.toFixed(2)}</td>
//                                   <td style={{ width: "10%", color: plPerShare > 0 ? "green" : plPerShare < 0 ? "red" : "black" }} className="td1">{plPerShare > 0 ? "+" : ""}{plPerShare.toFixed(2)}</td>
//                                   <td style={{ width: "10%", color: totalPL > 0 ? "green" : totalPL < 0 ? "red" : "black" }} className="td1">{totalPL > 0 ? "+" : ""}{totalPL.toFixed(2)}</td>
//                                 </tr>
//                               ];
//                             }
//                             // Show a row for each lot
//                             return lots.map((lot, idx) => {
//                               const purchaseValue = Number(lot.price) || 0;
//                               const currentValue = Number(player.currentValue) || 0;
//                               const shareQty = Number(lot.qty) || 0;
//                               const totalValue = currentValue * shareQty;
//                               const plPerShare = currentValue - purchaseValue;
//                               const totalPL = plPerShare * shareQty;
//                               return (
//                                 <tr key={`${player._id}-lot-${idx}`}>
//                                   <td style={{ width: "20%" }} className="td1">{player.name || "N/A"}</td>
//                                   <td style={{ width: "15%" }} className="td1">{purchaseValue.toFixed(2)}</td>
//                                   <td style={{ width: "15%" }} className="td1">{currentValue.toFixed(2)}</td>
//                                   <td style={{ width: "15%" }} className="td1">{shareQty}</td>
//                                   <td style={{ width: "15%" }} className="td1">{totalValue.toFixed(2)}</td>
//                                   <td style={{ width: "10%", color: plPerShare > 0 ? "green" : plPerShare < 0 ? "red" : "black" }} className="td1">{plPerShare > 0 ? "+" : ""}{plPerShare.toFixed(2)}</td>
//                                   <td style={{ width: "10%", color: totalPL > 0 ? "green" : totalPL < 0 ? "red" : "black" }} className="td1">{totalPL > 0 ? "+" : ""}{totalPL.toFixed(2)}</td>
//                                 </tr>
//                               );
//                             });
//                           })
//                         )}
//                       </tbody>
//                       <tfoot>
//                         <tr>
//                           <td colSpan="4" style={{ textAlign: "right", fontWeight: "bold" }}></td>
//                           <td className="td1" style={{ fontWeight: "bold" }}>
//                             {players.reduce(
//                               (sum, player) => sum + (Number(player.currentValue) || 0) * (Number(player.share_quantity) || 0),
//                               0
//                             ).toFixed(2)}
//                           </td>
//                           <td></td>
//                           <td className="td1" style={{ fontWeight: "bold", color: tableTotalPL > 0 ? "green" : tableTotalPL < 0 ? "red" : "black" }}>
//                             {tableTotalPL > 0 ? `+${tableTotalPL.toFixed(2)}` : tableTotalPL.toFixed(2)}
//                           </td>
//                         </tr>
//                       </tfoot>
//                     </Table>
//                   </div>
//                 </div>
//               )}

//               {/* History Details */}
//               {profileData.team && (
//                 <div className="mt-4 mb-5" style={{ height: "100%" }}>
//                   <h5 className="mt-3">History</h5>

//                   {/* Add scrollable player table */}
//                   <div>
//                     <Table
//                       striped
//                       bordered
//                       hover
//                       responsive
//                       style={{ width: "100%" }}
//                     >
//                       <thead>
//                         <tr>
//                           <th style={{ width: "14%" }}>DATE</th>
//                           <th style={{ width: "14%" }}>TYPE</th>
//                           <th style={{ width: "14%" }}>NAME</th>
//                           <th style={{ width: "12%" }}>VALUE</th>
//                           <th style={{ width: "12%" }}>BUY QTY</th>
//                           <th style={{ width: "12%" }}>SELL QTY</th>
//                           <th style={{ width: "12%" }}>TOTAL VALUE</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {(Array.isArray(tradingHistory) ? tradingHistory : [])
//                           .filter((tx) => Number(tx.quantity) > 0)
//                           .sort((a, b) => new Date(b.date) - new Date(a.date))
//                           .slice(
//                             (currentPage - 1) * itemsPerPage,
//                             currentPage * itemsPerPage
//                           )
//                           .map((tx, idx) => {
//                             const date = tx.date
//                               ? new Date(tx.date).toLocaleDateString("en-GB", {
//                                   day: "2-digit",
//                                   month: "2-digit",
//                                   year: "numeric",
//                                 })
//                               : "-";

//                             const isPlayerTransaction = tx.transaction_type === "player_transaction";
//                             const displayType = tx.type.replace(/_/g, ' ').toUpperCase(); // Format type (e.g., "WELCOME BONUS", "BUY")
//                             const displayName = tx.player_name || "-"; // Show "-" if no player name
//                             const displayValue = tx.value?.toFixed(2) || "-";
//                             const displayBuyQty = isPlayerTransaction && tx.type === "buy" ? tx.quantity : "-";
//                             const displaySellQty = isPlayerTransaction && tx.type === "sell" ? tx.quantity : "-";
//                             const displayTotalValue = (tx.total_value || 0).toFixed(2);

//                             return (
//                               <tr key={idx}>
//                                 <td>{date}</td>
//                                 <td>{displayType}</td>
//                                 <td>{displayName}</td>
//                                 <td>{displayValue}</td>
//                                 <td>{displayBuyQty}</td>
//                                 <td>{displaySellQty}</td>
//                                 <td>{displayTotalValue}</td>
//                               </tr>
//                             );
//                           })}
//                         {tradingHistory.length === 0 && (
//                           <tr>
//                             <td colSpan={7} style={{ textAlign: 'center' }}>
//                               <p>No History Found</p>
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </Table>
//                    {/* backup without history */}

//                     {/* <Table
//                       striped
//                       bordered
//                       hover
//                       responsive
//                       style={{ width: "100%" }}
//                     >
//                       <thead>
//                         <tr>
//                           <th style={{ width: "15%" }}>DATE</th>
//                           <th style={{ width: "15%" }}>NAME</th>
//                           <th style={{ width: "12%" }}>VALUE</th>
//                           <th style={{ width: "12%" }}>BUY QTY</th>
//                           <th style={{ width: "12%" }}>SELL QTY</th>
//                           <th style={{ width: "12%" }}>TOTAL VALUE</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {(Array.isArray(tradingHistory) ? tradingHistory : [])
//                           .filter((tx) => Number(tx.quantity) > 0)
//                           .sort((a, b) => new Date(b.date) - new Date(a.date))
//                           .slice(
//                             (currentPage - 1) * itemsPerPage,
//                             currentPage * itemsPerPage
//                           )
//                           .map((tx, idx) => {
//                             const date = tx.date
//                               ? new Date(tx.date).toLocaleDateString("en-GB", {
//                                   day: "2-digit",
//                                   month: "2-digit",
//                                   year: "numeric",
//                                 })
//                               : "-";

//                             return (
//                               <tr key={idx}>
//                                 <td>{date}</td>
//                                 <td>{tx.player_name}</td>
//                                 <td>{tx.value?.toFixed(2)}</td>
//                                 <td>{tx.type === "buy" ? tx.quantity : "-"}</td>
//                                 <td>{tx.type === "sell" ? tx.quantity : "-"}</td>
//                                 <td>{(tx.value * tx.quantity).toFixed(2)}</td>
//                               </tr>
//                             );
//                           })}
//                           {tradingHistory.length ===0 &&(
//                             <tr>
//                             <td colSpan={6} style={{ textAlign: 'center' }}>
//                               <p>No History Found</p>
//                             </td>
//                           </tr>
//                           )}
//                       </tbody>
//                     </Table> */}

//                     {/* Pagination */}
//                     <div className="d-flex justify-content-center mt-3">
//                       <nav>
//                         <ul className="pagination">
//                           <li
//                             className={`page-item ${
//                               currentPage === 1 ? "disabled" : ""
//                             }`}
//                           >
//                             <button
//                               className="page-link"
//                               onClick={() =>
//                                 setCurrentPage((prev) => Math.max(prev - 1, 1))
//                               }
//                               disabled={currentPage === 1}
//                             >
//                               Previous
//                             </button>
//                           </li>
//                           {[
//                             ...Array(
//                               Math.ceil(
//                                 (Array.isArray(tradingHistory)
//                                   ? tradingHistory.filter((tx) => Number(tx.quantity) > 0)
//                                   : []
//                                 ).length / itemsPerPage
//                               )
//                             ),
//                           ].map((_, index) => (
//                             <li
//                               key={index + 1}
//                               className={`page-item ${
//                                 currentPage === index + 1 ? "active" : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() => setCurrentPage(index + 1)}
//                               >
//                                 {index + 1}
//                               </button>
//                             </li>
//                           ))}
//                           <li
//                             className={`page-item ${
//                               currentPage ===
//                               Math.ceil(
//                                 (Array.isArray(tradingHistory)
//                                   ? tradingHistory.filter((tx) => Number(tx.quantity) > 0)
//                                   : []
//                                 ).length / itemsPerPage
//                               )
//                                 ? "disabled"
//                                 : ""
//                             }`}
//                           >
//                             <button
//                               className="page-link"
//                               onClick={() =>
//                                 setCurrentPage((prev) =>
//                                   Math.min(
//                                     prev + 1,
//                                     Math.ceil(
//                                       (Array.isArray(tradingHistory)
//                                         ? tradingHistory.filter((tx) => Number(tx.quantity) > 0)
//                                         : []
//                                       ).length / itemsPerPage
//                                     )
//                                   )
//                                 )
//                               }
//                               disabled={
//                                 currentPage ===
//                                 Math.ceil(
//                                   (Array.isArray(tradingHistory)
//                                     ? tradingHistory.filter((tx) => Number(tx.quantity) > 0)
//                                     : []
//                                   ).length / itemsPerPage
//                                 )
//                               }
//                             >
//                               Next
//                             </button>
//                           </li>
//                         </ul>
//                       </nav>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </Col>
//         </Row>
//         <div className="card-footer3">
//           <div className="footer">
//             <div className="footer-firstline">
//               <div className="footer-sub">
//                 <h4>Keep in touch</h4>
//                 <h5>Join our newsletter. We promise not to spam!</h5>
//                 <input
//                   type="email"
//                   placeholder="Email Address"
//                   className="footer-input"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//                 <button className="subscribe-btn" onClick={handleSubscribe}>
//                   Subscribe
//                 </button>
//                 {message && (
//                   <p style={{ marginTop: "10px", marginLeft: "5px" }}>
//                     {message}
//                   </p>
//                 )}
//               </div>

//               <div className="footer-sub1">
//                 <h4>Quick links</h4>
//                 <a href="/home" className="footer-link">
//                   Home
//                 </a>
//                 <a href="/profile" className="footer-link">
//                   Profile
//                 </a>
//                 <a href="/myteam" className="footer-link">
//                   My Team
//                 </a>
//                 <a href="/news" className="footer-link">
//                   News
//                 </a>
//                 <a href="/faq" className="footer-link">
//                   FAQs
//                 </a>
//                 {/* <a
//                   onClick={handleEmailClick}
//                   className="footer-link"
//                   style={{ cursor: "pointer" }}
//                 >
//                   Support
//                 </a> */}
//               </div>

//               <div className="footer-sub1 secondicon">
//                 <h4>Socials</h4>
//                 <div className="social-icons">
//                   <a
//                     href="https://www.facebook.com/toptennisio/"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="social-circle"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <i className="fab fa-facebook-f"></i>
//                   </a>
//                   <a
//                     href="https://www.instagram.com/toptennisuk"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="social-circle"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <i className="fab fa-instagram"></i>
//                   </a>
//                 </div>
//                 <div className="fl1">
//                   <a
//                     href="/terms"
//                     className="footer-link"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     T&Cs
//                   </a>
//                   <a
//                     href="/privacy"
//                     className="footer-link"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     Privacy Policy
//                   </a>
//                   <span className="footer-link">
//                     Email: contact@toptennis.io
//                   </span>
//                 </div>
//               </div>
//               {/* </div> */}
//             </div>
//           </div>
//         </div>
//       </Container>
//     </>
//   );
// }

// export default ProfilePage;
